//en,pt
export default {
	// Lang EN
	en: {
		fromOurTradition: 'From Our Tradition',	
		description: 'Description',
		price: 'Price',
		restaurantFood: 'Val Moreira Restaurant | Food',
		restaurantDrinks: 'Val Moreira Restaurant | Drinks',
		appetizers: 'Appetizers',
		appetizer_one: 'Green asparagus cream soup, crispy traditional smoked sausage and chives',
		appetizer_two: 'Our traditional green broth',
		appetizer_three: 'Fresh cheese salad with peach, smoked ham and almonds',
		appetizer_four: 'Grilled rustic bread with olive oil and garlic, traditional Lamego smoked sausage and quail egg',
		appetizer_five: 'Shrimps in tempura, mango, kiwi chutney, sweet chili and salad sprouts',
		dish_monday: 'Deep-fried meat-filled pastries with lima beans rice',
		dish_tuesday: 'Octopus fillets with broccoli rabe rice',
		dish_wednesday: 'Old-fashioned style duck rice',
		dish_thursday: 'Cod loins roasted with onions and boiled potatoes',
		dish_friday: 'Game meat pie with sautéed spinach',
		dish_saturday: 'Cavado river trouts with smoked ham and boiled potatoes',
		dish_sunday: 'Roast kid with potatoes and sautéed broccoli rabe',
		Cliente: 'Client',
		Orders: 'Room Service',
		account: 'Account',
		Estadia: 'Stay',
		Checkin: 'Check-In Online',
		vSelectNoResults: 'No results found.',
		vSelectNoOptions: 'No options available',
		EstadiasAnteriores: 'Past Stays',
		QuestionarioSatisfacao: 'Questionnaires',
		InstantFeedback: 'Instant Feedback',
		Cartas: 'Crata',
		Capitulo: 'Capitulo',
		Chapters: 'Chapters',
		Subcapitulos: 'Subcapitulo',
		MenuSetup: 'Setup',
		Restauracao: 'Menus',
		RestauranteValMoreiraComida: 'Val Moreira Restaurant | Menu',
		RestauranteValMoreiraBebidas: 'Val Moreira Restaurant | Drinks',
		BarValMoreira: 'Val Moreira Bar',
		PequenoAlmoco: 'Breakfast',
		ChaDas5: '5 O\'Clock Tea',
		MenuNep: 'NEP Menu',
		VinhosAdega: 'Wines / Winery',
		Gins: 'Gins',
		Servicos: 'Services',
		Piscina: 'Pool',
		Lavandaria: 'Loundry',
		Minibar: 'Minibar',
		VinhosAzeites: 'Wines / Olive Oil',
		RoomService: 'Room Service',
		Spa: 'Spa',
		DirectorioAZ: 'Directory A-Z',
		IvaCorrente: 'VAT Included at current rate.',
		LivroReclamacoes: 'This property has a complaint book.',
		PrevencaoAlergias: 'For the prevention of potential allergies, there is a technical sheet describing the ingredients used. No plate, food or drink, including the couvert, can be charged if not requested by the customer or it is rendered inoperable.',
		PrevencaoIncendios: 'Fire Prevention',
		EstadiaActual: 'Your Current Stay',
		ContaDeQuarto: 'Your Current Room Bill',
		pontoDeVenda: 'Sale Point',
		dataHora: 'Date',
		artigoFactura: 'Invoiced article',
		amount: 'Amount',
		billConfirmation: 'Confirmed',
		SuasEstadiasAnteriores: "Your past Stays",
		WakeUp: "Wake Up Service",
		naoPerturbar: "Do Not Disturb Service",
		suporte: "Maintenance",
		Produtos: "Products",
		Welcome_M: "Welcome",
		Welcome_F: "Welcome",
		gerirConteudos: "Conteúdos",
		gerirUtilizadores: "Permissões",
		pesquisarUtilizador: "Search User",
		Administracao: "Management",
		editUserRole: "Edit Permissions",
		insertUserId: "Email, Id or Name",
		Gravar: "Save",
		roleActual: "Permission",
		roleSuccess: "Role changed with success.",
		gerirConteudoMain: "Manage Main Page Content",
		directorio: "Directory",
		main_page: "Homepage",
		edit_hotel: "Select the Hotel to edit: ",
		current_hotel: "Current Hotel",
		select_hotel: "Select Hotel",
		corporate_images: "Corporate Images",
		password: 'Password',
		register: 'Register',
		user: 'User',
		user_email: 'Username or Email',
		invalid_credentials: 'Invalid credentials',
		attention: 'Attention.',
		mandatory_user: 'The user field is mandatory.',
		mandatory_password: 'The password field is mandatory.',
		login_password: 'The fields user and password are mandatory.',
		error_password: 'Invalid password.',
		added_item_to_cart: 'Item successfully added to cart.',
		order_placed: 'Your order was successfully placed.',
		success: 'Success.',
		order_error: 'There was an error while placing your order, please try again.',
		user_not_found: 'No records were found.',
		empty_search_filed: 'The search field can not be empty.',
		en: 'English',
		pt: 'Portuguese',
		br: 'Portuguese',
		de: 'German',
		fr: 'French',
		es: 'Spanish',
		dont_show_popup: "Don't show this message again.",
		empty_feedback: 'There are questions with no answer selected.',
		feedback_comments: 'Comments (optional)',
		feedback_thanks: 'Thank you for your feedback.',
		noFeedback: 'Instant feedback unavailable because there is no stay in progress.',
		submit: "Submit",
		long_comment_feedback: "Your comments exceeded the character limit.",
		corporate_banners: 'Vila Galé Group',
		changeRole: 'Role successfully changed.',
		addRole: 'Role successfully added.',
		removeRole: 'Role SUccessfully removed.',
		instantFeedback: 'Instant Feedback',
		noAvailableFeedback: 'Instant feedback unavailable because there is no stay in progress.',
		legalNotice: 'Legal Notice',
		legalNoticeUrl: 'https://www.vilagale.com/en/privacy-policy',
		privacyPolicy: 'Policy Privacy',
		privacyPolicyUrl: 'https://www.vilagale.com/en/legal-notice',
		complaintsBook: 'Complaints Book',
		complaintsBookUrl: 'https://www.livroreclamacoes.pt/inicio/',
		Noticias: 'News',
		Carta: 'Carta',
		Cartas: 'Cartas',
		noCheckin: 'There are no reservations for Check-In Online.',
		noSurvey: 'There are no questionnaires to answer.',
		questionnaires: 'Questionnaires',
		reservation: 'Reservation',
		answer: 'Answer',
		open: 'Open',
		CartasSide: 'Menus',
		noOrders: "There are no orders placed",
		emptyCart: "Your Cart Is Empty.",
		returnButton: 'Return',
		description: 'Description',
		noMenus: 'There are no menus available.',
		noItems: 'There are no items available.',
		noChapter: 'Menu is not available.',
		noDirectory: 'Directory A-Z not available.',
		noDirectoryLang: 'Directory A-Z not available for this language.',
		noItemsAvailable: 'There are no items available.',
		quantity: 'Quantity',
		noItemsInCart: 'There are no items in your cart.',
		seeMenus: 'View Menus',
		save_item_rejected: 'Save',
		finishOrder: 'Confirm',
		remove: 'Remove',
		notes: 'Observations',
		noStay: 'Room Service unavailable because there is no stay in progress.',
		placedOrders: 'Placed Orders',
		cancels: 'Cancel',
		yourCart: 'Your cart.',
		noPlacedOrders: 'There are no orders placed.',
		revocerPassword: 'Forgot password?',
		item: 'Item',
		local: 'Local',
		date: 'Date',
		account_quantity: 'Qty.',
		value: 'Value',
		reject: 'Reject',
		Noticia: 'News',
		Questionario: 'Quiz',
		Voltar: 'Return',
		Comentario: 'Comment',
		Comentar: 'Comment',
		Ver_mais: 'See More',
		Saber_mais: 'Know more',
		nao_foram_encontradas_noticias: 'No news was found.',
		Todas: 'All',
		Comidas: 'Foods',
		Bebidas: 'Drinks',
		Outras: 'Others',
		Filtro: 'Filter',
		Pesquisa: 'Search',
		Perfil: 'Profile',
		Clube: 'Club',
		send_account_info: 'Send',
		reject_items_question: 'Please tell us the why.',
		approved : "Approved",
		to_send : "Pedding",
		rejected_at : "Rejected at",
		rejected : "Rejected",
		status : "Status",
		payments: "Payment",
		pago    : "Paid",
		client_accounts: 'Client Accounts',
		client_account: 'Client Account',
		end_payment : 'Payment Checkout',
		account_no_items : 'There are no items for this account',
		Informations: 'Informations',
		Nao_existem_conteudos_hotel_selecionado: 'There is no content for the selected hotel.',
		Selecione_hotel_ver_conteúdo: 'Select a hotel to view its content.',
		success_rsv_checkout : 'Check-out done successfully.',
		account_no_items : 'There are no registered consumptions.',
		success_rsv_checkout : 'Your check out has been successfully completed!<br>Leave the key card(s) of your room(s) at the Reception desk in the designated box.<br><br>We thank you for your preference and we look forward to seeing you soon!',
		checkout_text_w_items: 'There are open values ​​in your reservation. Please confirm that everything is correct',
		checkout_text_no_items: 'Check out quickly and with ease. Click the button below:',
		checkout_warning: 'Please go to the reception desk to check out.',
		checkout_warning_w_rejected: 'Please go to the Reception desk to verify your bill.',
		client_account_sentence: 'Please confirm your consumption during your stay in the list below.',
		confirmed_account_msg: 'Confirmation successfully registered.',
		discount: 'Discount',
		checkout_done: 'Option available only when there is a stay in progress.',
		appointments: 'Bookings',
		animation: 'Animation',
		laundry: 'Laundry',
		associate_rsv: 'Link to an existing reservation',
		rsv_number: 'Reservation Nº',
		your_rsv: 'Your Reservation',
		your_next_rsv: 'Your Next Reservation',
		room_number: 'Room Nº',
		rsv_succed: 'Reservation created successfully.',
		str_hour_schedule: 'From {start_time} to {end_time}',
		bookings_no_items: 'There are no registered reservations.',
		my_appointments: 'My Reservations',
		people_n: 'Nº of People',
		service: 'Service',
		service_type: 'Service Type',
		horario: 'Hours',
		horarios: 'Hours',
		space: 'Space',
		space_type: 'Space Type',
		availability: 'Availability',
		type_of: 'Type of',
		dish: 'Dish',
		newa: 'New',
		newo: 'New',
		cancelled: 'Cancelled',
		aviso: 'Alert',
		yes: 'Yes',
		no: 'No',
		my_bookings_sentence: 'See your reservations in the list below.',
		Entretenimento: 'Entertainment',
		Noticiass: 'Noticias',
		Eventos: 'Events',
		Eventoss: 'Eventos',
		payment_msg: "You can pay for the goods and services consumed now or later, at the hotel's Reception desk.",
		consult: 'Consult',
		no_spaces: 'It is not possible to make appointments. Please contact the reception.',
		no_shedules: 'There are no schedules available. Please contact the reception.',
		booking_removed: 'Reservation removed successfully.',
		Configuration: 'Configuration',
		error: 'Error',
		VilaGaleSTAR: 'Vila Galé STAR',
		Inovar_Motivar: 'Inovar Motivar',
		Configuration: 'Configuration',
		check_cartas_login: 'Do you want to check our menus?<br>Click',
		check_entertainment_login: 'Do you want to check our entertainment programs?<br>Click',
		here: 'here',
		Parcerias: 'Partnerships',
		Parceriass: 'Parcerias',
		Categorias: 'Categories',
		Todos: 'All',
		payment_success : 'Payment successful',
		hotel: 'Hotel',
		payment_pending : 'Payment is pending. Please, access the application and authorize payment.',
		no_reservations_available: 'There are no reservations available.',
		recover_1: 'Your log-in details have been sent to the e-mail address',
		recover_2: '. If you did not receive our e-mail (check all folders, including the Spam folder), click',
		recover_3: 'to have the e-mail sent again.',
		just_a_second: 'Just a second...',
		recover_aqui: 'here',
		contact: 'An error has occurred. Please contact us.',
		recover_title: 'Password Recovery',
		erro_date: 'Error with selected date.',
		new_password: 'New Password',
		new_password_desc: 'You must change your password before logging in to ',
		password_changed: 'Your new password has been successfully registered.',
		submeter: 'Submit',
		missing_pass: 'The “Password” field is required.',
		missing_conf_pass: 'The “Confirm Password” field is required.',
		pass_not_match: 'The “Password” and “Confirm Password” fields do not match.',
		tipo_de_marcacao: 'Tipo de Marcação',
		tipo_de_espaco: 'Type of Space',
		data_do_registo: 'Registration Date',
		mesas: 'Tables',
		n_quarto: 'Room No.',
		grupo: 'Group',
		n_presenças: 'No. of Attendees',
		registado_por: 'Registered By',
		observacoes: 'Observations',
		nome: 'Name',
		n_grupo: 'Group No.',
		regime: 'Regime',
		n_presencas: 'Number of Attendance',
		ver: 'Watch',
		n_presencas_registado: 'Nº de presenças registado com sucesso.',
		erro_numero_distribuicao_reserva: 'Erro - numero da distribuição da reserva',
		erro_numero_pessoas: 'Erro - numero de pessoas',
		erro_guardar_n_presencas: 'Erro ao guardar o Nº Presenças.',
		Pesquisar: 'Search',
		obrigatorio_inserir_n_reserva_n_quarto: 'Es obligatorio introducir el Número de Reserva o Número de Habitación.',
		sair: 'Exit',
		Limpar: 'Clean',
		Grupos: 'Groups',
		Passante: 'Passerby',
		Reserva: 'Reservation',
		Pessoas: 'People',
		Houve_um_colega_que_se_destacou: 'Was there a colleague who stood out?',
		Nomeia_o_para_o_Vila_Gale_Star: 'Nominate them for the Vila Galé Star!',
		Todos_os_meses_e_eleito_um_vencedor: 'Every month, a winner is chosen!',
		Quem_sabe_se_tu_nao_seras_o_proximo: 'Who knows, maybe you\'ll be the next one!',
		Ano: 'Year',
		Trimestre: 'Quarter',
		Mes: 'Month',
		Portugal: 'Portugal',
		E_a_cada_3_meses: 'And, every 3 months,',
		havera_uma_decisao_com_premio: 'there will be a decision with a prize!',
		Quem_sabe_se_es_o_proximo: 'Who knows if you are the next!',
		Faz_nos_Brilhar: 'Make us Shine!',
		Regulamento: 'Regulations',
		Nomear: 'Nominate',
		Finalidade: 'Purpose',
		O_programa_visa_evidenciar_o_merito_do_desempenho_dos: 'The program aims to highlight the merit of the performance of employees, in a decision-making model that is participatory by other members of the unit or department.',
		Metodo: 'Method',
		O_programa_divide_se_em_4_fases: 'The program is divided into 4 phases:',
		Mensal: 'Monthly',
		votacao: 'Voting',
		a_votacao_doa_vg_star_mensal_e_feita_atraves_das: 'The voting for the VG STAR Monthly is done through nominations from colleagues on the ISL notice board, My Vila Galé, and ERP forms, from customers through internal satisfaction questionnaires and other digital platforms, and in management meetings.',
		eleicao: 'Election',
		a_eleicao_do_vg_star_mensal_e_feita_atraves_da: 'The election of the VG STAR Monthly is done through the weighting of colleagues\' nominations (40%), customer mentions (40%), and management meetings (20%). The winner must be announced on the last day of each month. There will be no election in December.',
		premios: 'Prizes',
		ao_vencedor_do_vg_star_mensal_e_atribuido: 'The winner of the VG STAR Monthly is awarded:',
		o_premio_de_5000_em_vale_valor_ivla_gale_carregados: 'The prize of €50.00 in Vila Galé Value Voucher, loaded into the profile on ERP;',
		sera_divulgadoa_oa_vencedora_atraves: 'The winner will be announced through the ISL notice board.',
		criterios_de_nao_eleicao: 'Non-election Criteria',
		falta_injustificada_no_mes_da_nomeacao: 'Unjustified absence in the month of nomination;',
		advertencia_por_escrito: 'Written warning;',
		reclamacoes_com_o_seu_nome: 'Complaints with your name;',
		ter_sido_eleito_a_no_presente_trimestre: 'Having been elected in the current quarter.',
		trimestral: 'Quarterly',
		oa_vg_star_trimestral_sera_uma_dosas_colegas: 'The VG STAR Quarterly will be one of the colleagues from the same unit who won the VG STAR Monthly in the previous 3 months.',
		a_eleicao_do_vg_star_trimestral_e_feita_atraves: 'The election of the VG STAR Quarterly is done through a management meeting considering the 3 colleagues who won in the previous months. The winner will be announced by the 15th of the month following the end of the quarter, except in December. (April 15, July 15, October 15, December 5).',
		ao_vencedora_do_vg_star_trimestral_sao: 'The winner of the VG STAR Quarterly is awarded:',
		em_vale_valor_carregados_no_profile_em_erp_50: '€50.00 in Value Vouchers loaded into the profile on ERP (accumulated with the €50.00 from the VG Star Monthly);',
		badge_com_estrela_que_devera_ser_utilizado_durante: 'Star badge to be worn throughout the year;',
		sera_divulgado_a_o_a_vencedor_a_para_os_clientes: 'The winner will be announced to customers through the reception TV and the My Vila Galé portal.',
		falta_injustificada_no_trimestre: 'Unjustified absence in the quarter;',
		advertencia_por_escrito: 'Written warning;',
		atrasos_injustificados_no_trimestre: 'Unjustified delays in the quarter;',
		altercacoes: 'Altercations;',
		ter_sido_nomeado_vg_star_trimestre_no_presente_ano: 'Having been nominated VG STAR (quarter) in the current year.',
		a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de: 'The election of the VG SUPERSTAR Hotel takes place through a management meeting until December 5th of each year. The elected person must be one of the VG STARs from the four quarters.',
		aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios: 'The winner of the VG SUPERSTAR Hotel is awarded',
		em_vale_valor_carregados_no_profile_em_erp_100: '€100.00 in Value Vouchers loaded into the profile on ERP',
		um_cabaz_de_Natal_e_osas_vencedoresas_serão_anunciados: 'a Christmas basket, and the winners will be announced at the Christmas Party',
		sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL: 'The winner will be announced through the ISL notice board and to customers through the reception TV and the My Vila Galé portal',
		todas_os_criterios_referidos_no_vg_star: 'All criteria referred to in VG STAR;',
		nao_ter_sido_vencedora_do_vg_star: 'Not having been a VG STAR winner.',
		Nacional: 'National',
		oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos: 'The VG SUPERSTAR National is done through the analysis of the VG SUPERSTAR winners from each hotel',
		a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri: 'The election of the VG SUPERSTAR National is done by a jury composed of the Operations Management, Administration, and Financial Management.',
		ao_vencedor_do_vg_superstar_nacional_sao_atribuidos: 'The winner of the VG SUPERSTAR National is awarded',
		em_vale_valor_carregados_no_profile_em_erp_200: '€200.00 in Value Vouchers loaded into the profile on ERP;',
		oa_vencedora_sera_convidadoa_a_estar_presente: 'The winner will be invited to attend the group\'s Annual Convention and will be mentioned in E-feel Staff, My Vila Galé, and Whatsapp;',
		sera_divulgado_o_vencedor_para_os_clientes: 'The winner will be announced to customers through the reception TV and the My Vila Galé portal.',
		todas_os_criterios_referidos_no_vg_star: 'All criteria referred to in VG STAR;',
		nao_ter_sido_vencedor_a_do_vg_star: 'Not having been a VG STAR winner.',
		Nenhum_colaborador_encontrado: 'No employee found',
		O_campo_Colaborador_é_obrigatório: 'The Employee field is mandatory',
		O_campo_Motivo_é_obrigatório: 'The Reason field is mandatory',
		Passou_o_limite_de_caracteres_para_o_campo_Motivo: 'You have exceeded the character limit for the Reason field',
		Nomeação_registada_com_sucesso: 'Thank you for your nomination.',
		Este_mês_já_fez_uma_nomeação: 'You have already made a nomination this month',
		SelecionarIdioma: 'Select Language',
		Idioma: 'Language',
		Nova: 'New',
		Link: 'Link',
		Corporativo: 'Corporate',
		PortuguêsPT: 'Portuguese PT',
		PortuguêsBR: 'Portuguese BR',
		O_tamanho_máximo_permitido_para_a_imagemé_de_200kb: 'The maximum allowed image size is 200kb',
		As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório: 'Image dimensions must be 500px x 500px (mandatory)',
		Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif: 'Images must be of type \'.jpg\', \'.jpeg\', \'.png\' or \'.gif\'',
		O_campo_Idioma_é_obrigatório: 'The Language field is mandatory',
		O_campo_Hotel_é_obrigatório: 'The Hotel field is mandatory',
		Registo_criado_com_sucesso: 'Record created successfully',
		Ocorreu_um_erro_ao_criar_o_registo: 'An error occurred while creating the record',
		Registo_eliminado_com_sucesso: 'Record deleted successfully',
		Ocorreu_um_erro_ao_eliminar_o_registo: 'An error occurred while deleting the record',
		INOVAR: "INNOVATE",
		MOTIVAR: "MOTIVATE",
		Inovar_Motivar: "Innovate Motivate",
		Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar: "Participate in the Innovate Motivate program and qualify to win €75.",
		Vamos_contribuir_para_a_mudança_do_nosso_grupo: "Let's contribute to the change in our group!",
		Inova_e_Ganha: "Innovate and Win!",
		Participar: "Participate",
		O_programa_visa_incentivar_a_participação_de_todos_no: "The program aims to encourage everyone's participation in the company's development, valuing their ideas and suggestions, and creating greater involvement and connection between all employees and Vila Galé.",
		As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada: "Ideas or suggestions received by the end of each quarter will be evaluated by a VG LAB.",
		Para_participar_basta_preencher_o_formulário_em_papel: "To participate, simply fill out the form on paper or online (ERP/My Vila Galé).",
		As_ideias_apresentadas_serão_classificadas_em: "The ideas presented will be classified into 3 criteria:",
		Relevantes_e_finalizadas_para_implementação_premiadas: "Relevant and finalized for implementation - awarded;",
		Desenvolvimento_o_a_colaborador_a_será_convidado: "Development - the employee will be invited to improve their idea so that it becomes feasible;",
		Não_relevantes: "Not relevant.",
		A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor: "The awarded idea(s) receive a prize worth €75 in Sonae card or €100 in VG Incentive Voucher.",
		Fatores_eliminatórios_apenas_a_sugestão_ou_ideia: "Eliminatory factors (only the suggestion or idea appropriate to them will be eligible for nomination):",
		Inovação_e_originalidade: "Innovation and originality",
		Valor_acrescentado_para_a_empresa: "Added value to the company",
		Necessidade_de_implementação: "Need for implementation",
		Exequibilidade_operacional: "Operational feasibility",
		Método_de_implementação: "Implementation method",
		Custos_de_implementação: "Implementation costs",
		As_ideias_ou_sugestões_relevantes_não_serão_premiadas: "Relevant ideas or suggestions will not be awarded in the first stage, but may be after development by the employee.",
		Em_caso_de_ideias_similares_apenas_uma_será_premiada: "In the case of similar ideas, only one will be awarded. Following the order of selection:",
		Mais_critérios_eliminatórios_adequados: "More appropriate eliminatory criteria;",
		Custos_de_implementação_calculados: "Calculated implementation costs;",
		Data_de_submissão: "Submission date.",
		Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir: "The VG LAB evaluator reserves the right not to award prizes if no idea is presented or if the ideas presented do not meet the conditions for awarding the prizes.",
		Colaborador: "Employee",
		Motivo: "Reason",
		Assunto: "Subject",
		Categoria: "Category",
		Descrição: "Description",
		Ficheiro: "File",
		Imagem: "Image",
		Tipo: "Type",
		Não_foram_encontradas_cartas_para_o_hotel_selecionado: "No letters were found for the selected hotel.",
		Menu: "Menu",
		Directório: "Directory",
		Marcação: "Marking",
		Capitulo: "Chapter",
		Erro_nos_subcapitulos: "Error in subchapters.",
		Carta_copiada_com_sucesso: "Letter copied successfully.",
		Erro_a_gravar: "Error saving",
		O_campo_Hotel_é_obrigatório: "The Hotel field is required.",
		Deseja_mesmo_apagar: "Do you really want to delete?",
		Pretende_eliminar: "Do you intend to delete",
		Erro_a_obter_hoteis: "Error obtaining hotels",
		Visivel: "Visible",
		Nome_Impressão: "Print Name",
		Informação: "Information",
		moeda: "currency",
		Moeda: "Currency",
		armazem: "warehouse",
		Armazém: "Warehouse",
		Remover_Imagem: "Remove Image",
		Adicionar_Imagem: "Add Image",
		As_dimensões_da_imagem_devem_ser_800px_x_600px: "The image dimensions must be 800px x 600px (mandatory).",
		Esta_carta_já_foi_registada: "This letter has already been registered.",
		Registo_alterado_com_sucesso: "Record successfully changed",
		Registo_criado_com_sucesso: "Record created successfully.",
		Ocorreu_um_erro_ao_alterar_o_registo: "An error occurred while changing the record",
		Ocorreu_um_erro_ao_criar_o_registo: "An error occurred while creating the record.",
		O_campo_Nome_é_obrigatório_no_idioma: "The Name field is required in the language",
		O_campo_Moeda_é_obrigatório: "The Currency field is required.",
		O_campo_Armazém_é_obrigatório: "The Warehouse field is required.",
		O_campo_Categoria_é_obrigatório: "The Category field is required.",
		Ocorreu_um_erro: "An error occurred.",
		Artigo_de_Venda: "Sales Item",
		Este_menu_já_foi_registado: "This menu has already been registered.",
		Ordem_n: "Order (º)",
		Adicionar: "Add",
		Não_foram_encontrados_capítulos: "No chapters were found.",
		O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a: "The Order field must be numeric and greater than or equal to 0.",
		O_campo_Nome_é_obrigatório: "The Name field is required.",
		Medidas: "Measures",
		Artigo_de_Venda: "Sales Item",
		Atualizar: "Update",
		Não_foram_encontrados_subcapítulos: "No subchapters were found",
		Litro: "Liter",
		Decilitro: "Deciliter",
		Centilitro: "Centiliter",
		Mililitro: "Milliliter",
		Minuto: "Minute",
		Não_foram_encontrados_capítulos_para_o_idioma_seleccionado: "No chapters were found for the selected language.",
		O_campo_Quantidade_é_obrigatório: "The Quantity field is required.",
		O_campo_Medida_é_obrigatório: "The Measure field is required.",
		O_campo_Preço_deve_ser_numérico: "The Price field must be numeric.",
		O_campo_Preço_é_obrigatório_e_deve_ser_numérico: "The Price field is required and must be numeric.",
		Não_foram_adicionadas_medidas: "No measures were added.",
		O_campo_Preço_é_obrigatório: "The Price field is required.",
		Zonas: "Zones",
		Data_de_Validade: "Expiration Date",
		Upload: "Upload",
		Destaque: "Highlight",
		Pública: "Public",
		Privada: "Private",
		Resposta1: "1 Answer",
		Várias_Opções: "Multiple Options",
		Resposta: "Answer",
		A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif: "The image must be of type jpeg, jpg, png or gif",
		O_ficheiro_tem_de_ser_um_pdf: "The file must be a pdf.",
		Lista_de_Notícias: "News List",
		Autor: "Author",
		Detalhe: "Detail",
		Data_Inicio: "Start Date",
		Data_Fim: "End Date",
		Evento_apagado: "Event deleted.",
		Deseja_mesmo_apagar_o_evento: "Do you really want to delete the event?",
		Apagar: "Delete",
		O_evento_será_apagado_e_não_será_possível_recuperá_lo: "The event {name} will be deleted and it will not be possible to recover it.",
		Privado: "Private",
		Não_é_possível_visualizar_o_documento: "It is not possible to view the document.",
		Já_chegou_ao_limite_de_ficheiros: "You have reached the file limit.",
		Apenas_são_aceites_PDFs_documentos_Word_ou_imagens: "Only PDFs, Word documents or images in jpeg, jpg or png format are accepted.",
		O_ficheiro_não_pode_ter_mais_de_10mb: "The file cannot be larger than 10mb.",
		O_campo_Assunto_é_obrigatório: "The Subject field is required.",
		O_campo_Categoria_é_obrigatório: "The Category field is required.",
		O_campo_Descrição_é_obrigatório: "The Description field is required.",
		Passou_o_limite_de_caracteres_para_o_campo_Descrição: "You have exceeded the character limit for the Description field.",
		Participação_registada_com_sucesso: "Participation registered successfully.",
		Este_directório_já_foi_registado: "This directory has already been registered.",
		Só_é_permitido_um_directório_por_hotel: "Only one directory is allowed per hotel.",
		Ficheiros: "Files",
		Data_de_Início: "Start Date",
		Data_de_Fim: "End Date",
		A_Data_de_Início_não_está_selecionada: "The Start Date is not selected.",
		A_Data_de_Fim_não_está_selecionada: "The End Date is not selected.",
		Titulo: "Title"

	},
	// Lang EN




	// Lang PT
    pt: {
		fromOurTradition: 'Da nossa Tradição',	
		description: 'Descrição',
		price: 'Preço',
		restaurantFood: 'Restaurante Val Moreira | Carta',
		restaurantDrinks: 'Restaurante Val Moreira | Bebidas',
		appetizers: 'Entradas',
		appetizer_one: 'Creme de espargos verdes, crocante de salpicão e cebolinho',
		appetizer_two: 'O nosso caldo verde',
		appetizer_three: 'Salada de queijo fresco, pêssego, presunto serrano e amêndoas',
		appetizer_four: 'Torricado de alheira de Lamego com ovo de codorniz',
		appetizer_five: 'Camarão em tempura, manga, chutney de kiwi, chili doce e rebentos de salada',
		dish_monday: 'Pastéis de massa tenra com arroz de feijão manteiga',
		dish_tuesday: 'Filetes de polvo com arroz de grelos',
		dish_wednesday: 'Arroz de pato à antiga',
		dish_thursday: 'Lombos de bacalhau à Margarida da Praça',
		dish_friday: 'Empada de caça com espinafres salteados',
		dish_saturday: 'Trutas do rio Cavado com presunto e batata cozida',
		dish_sunday: 'Cabrito assado com batata e grelos salteados',
		Cliente: 'Cliente',
		Orders: 'Room Service',
		account: 'Conta',
		Estadia: 'Estadia',
		Checkin: 'Check-In Online',
		vSelectNoResults: 'Sem resultados.',
		vSelectNoOptions: 'Sem opções disponíveis',
		EstadiasAnteriores: 'Estadias Anteriores',
		QuestionarioSatisfacao: 'Questionários',
		InstantFeedback: 'Feedback Instantâneo',
		Cartas: 'Cartas',
		Capitulo: 'Capitulo',
		Chapters: 'Capítulos',
		Subcapitulos: 'Subcapitulo',
		MenuSetup: 'Setup',
		Restauracao: 'Cartas',
		RestauranteValMoreiraComida: 'Restaurante Val Moreira | Comida',
		RestauranteValMoreiraBebidas: 'Restaurante Val Moreira | Bebidas',
		BarValMoreira: 'Bar Val Moreira',	
		PequenoAlmoco: 'Pequeno Almoço',
		ChaDas5: 'Chá das 5',
		MenuNep: 'Menu NEP',
		VinhosAdega: 'Vinhos / Adega',
		Gins: 'Gins',
		Servicos: 'Serviços',
		Piscina: 'Piscina',
		Lavandaria: 'Lavandaria',
		Minibar: 'Minibar',
		VinhosAzeites: 'Vinhos / Azeites',
		RoomService: 'Serviço de Quartos',
		Spa: 'Spa',
		DirectorioAZ: 'Directório A-Z',
		IvaCorrente: 'IVA Incluído à taxa corrente.',
		LivroReclamacoes: 'Este estabelecimento dispõe de livro de reclamações.',
		PrevencaoAlergias: 'Para prevenção de potenciais alergias, existe ficha técnica com a descrição dos ingredientes utilizados. Nenhum prato, produto alimentar ou bebida, incluindo o couvert, pode ser cobrado se não for solicitado pelo cliente ou por este for inutilizado.',
		PrevencaoIncendios: 'Prevenção de Incêndios',
		EstadiaActual: 'A Sua Estadia',
		ContaDeQuarto: 'A Sua Conta Actual',
		pontoDeVenda: 'Ponto de Venda',
		dataHora: 'Data e Hora',
		artigoFactura: 'Artigo de Factura',
		amount: 'Valor',
		billConfirmation: 'Confirmado',
		SuasEstadiasAnteriores: "As suas estadias anteriores",
		WakeUp: "Serviço Despertar",
		naoPerturbar: "Serviço Não Perturbar",
		suporte: "Pedido de Manutenção",
		Produtos: "Produtos",
		Welcome_M: "Bem-vindo",
		Welcome_F: "Bem-vinda",
		gerirConteudos: "Conteúdos",
		gerirUtilizadores: "Permissões",
		pesquisarUtilizador: "Pesquisar Utilizador",
		Administracao: "Administração",
		editUserRole: "Editar permissão",
		insertUserId: "Email, Id ou Nome",
		Gravar: "Gravar",
		roleActual: "Permissão",
		roleSuccess: "Nivel alterado com sucesso.",
		gerirConteudoMain: "Gerir Conteúdos da Página Principal",
		directorio: "Directório",
		main_page: "Homepage",
		edit_hotel: "Escolha o Hotel para editar: ",
		current_hotel: "Hotel Actual",
		select_hotel: "Escolher Hotel",
		corporate_images: "Imagens Corporativas",
		password: 'Senha',
		register: 'Registar',
		user: 'Utilizador',
		user_email: 'Utilizador ou Email',
		invalid_credentials: 'Credenciais inválidas',
		attention: 'Atenção.',
		mandatory_user: 'O campo utilizador é obrigatório.',
		mandatory_password: 'O campo senha é obrigatório.',
		login_password: 'Os campos utilizador e senha são obrigatórios.',
		error_password: 'Password incorrecta',
		added_item_to_cart: 'Item adicionado ao carrinho com sucesso.',
		order_placed: 'Seu pedido foi realizado com sucesso.',
		success: 'Sucesso.',
		order_error: 'Erro ao processar pedido, por favor tente novamente.',
		user_not_found: "Não foram encontrados registos.",
		empty_search_filed: 'O campo de pesquisa deve estar preenchido',
		en: 'Inglês',
		pt: 'Português',
		br: 'Português',
		de: 'Alemão',
		fr: 'Francês',
		es: 'Espanhol',
		dont_show_popup: 'Não mostrar esta mensagem novamente',
		empty_feedback: 'Existem perguntas sem resposta selecionada.',
		feedback_comments: 'Comentários (opcional)',
		feedback_thanks: 'Obrigado pelo seu feedback.',
		noFeedback: 'Feedback instantâneo indisponível porque não existe uma estadia a decorrer.',
		submit: "Submeter",
		long_comment_feedback: "Seu comentário ultrapassa os limites de carateres.",
		corporate_banners: 'Grupo Vila Galé',
		changeRole: 'Registo alterado com sucesso.',
		addRole: 'Registo criado com sucesso.',
		removeRole: 'Registo removido com sucesso.',
		instantFeedback: 'Feedback instantâneo',
		noAvailableFeedback: 'Feedback instantâneo indisponível porque não existe uma estadia a decorrer.',
		legalNotice: 'Aviso Legal',
		legalNoticeUrl: 'https://www.vilagale.com/pt/aviso-legal',
		privacyPolicy: 'Politica de Privacidade',
		privacyPolicyUrl: 'https://www.vilagale.com/pt/politica-de-privacidade',
		complaintsBook: 'Livro de Reclamações',
		complaintsBookUrl: 'https://www.livroreclamacoes.pt/inicio/',
		Noticias: 'Notícias',
		Carta: 'Carta',
		noCheckin: 'Não existem reservas para realizar o Check-In Online.',
		noSurvey: 'Não existem questionários para responder.',
		questionnaires: 'Questionários',
		reservation: 'Reserva',
		answer: 'Responder',
		open: 'Abrir',
		CartasSide: 'Cartas',
		noOrders: 'Não existem pedidos realizados.',
		emptyCart: "Seu carrinho está vazio",
		returnButton: 'Voltar',
		description: 'Descrção',
		noMenus: 'Não existem cartas disponíveis.',
		noItems: 'Itens não disponíveis.',
		noChapter: 'Carta não disponível.',
		noDirectory: 'Directório A-Z não disponível.',
		noDirectoryLang: 'Directório A-Z não disponível para este idioma.',
		noItemsAvailable: 'Itens não disponíveis.',
		quantity: 'Quantidade',
		noItemsInCart: 'Não existem itens no seu carrinho.',
		seeMenus: 'Var Cartas',
		save_item_rejected: 'Guardar',
		finishOrder: 'Confirmar',
		remove: 'Remover',
		notes: 'Observações',
		noStay: 'Room Service indisponível porque não existe uma estadia a decorrer.',
		placedOrders: 'Pedidos Realizados',
		cancels: 'Cancelar',
		yourCart: 'Seu carrinho.',
		noPlacedOrders: 'Não existem pedidos realizados.',
		revocerPassword: 'Esqueceu a senha?',
		item: 'Artigo',
		local: 'Local',
		date: 'Data',
		account_quantity: 'Qtd.',
		value: 'Valor',
		reject: 'Rejeitar',
		Noticia: 'Notícia',
		Questionario: 'Questionário',
		Voltar: 'Voltar',
		Comentario: 'Comentário',
		Comentar: 'Comentar',
		Ver_mais: 'Ver Mais',
		Saber_mais: 'Saber mais',
		nao_foram_encontradas_noticias: 'Não foram encontradas notícias.',
		Todas: 'Todas',
		Comidas: 'Comidas',
		Bebidas: 'Bebidas',
		Outras: 'Outras',
		Filtro: 'Filtro',
		Pesquisa: 'Pesquisa',
		Perfil: 'Perfil',
		Clube: 'Clube',
		send_account_info: 'Enviar',
		reject_items_question: 'Indique-nos o motivo.',
		approved : "Aprovado",
		to_send : "Por Enviar",
		rejected_at : "Rejeitado a",
		rejected : "Rejeitado",
		status : "Estado",
		payments: "Pagamento",
		pago    : "Pago",
		client_accounts: 'Contas de Cliente',
		client_account: 'Conta de Cliente',
		end_payment : 'Finalizar Pagamento',
		account_no_items : 'Não existem artigos para esta conta',
		Informations: 'Informações',
		Nao_existem_conteudos_hotel_selecionado: 'Não existem conteúdos para o hotel selecionado.',
		Selecione_hotel_ver_conteúdo: 'Selecione um hotel para ver o seu conteúdo.',
		success_rsv_checkout : 'Check-out bem sucedido',
		account_no_items : 'Não existem consumos registados.',
		success_rsv_checkout : 'O seu Check-Out foi realizado com sucesso.<br>Por favor deixe a(s) chave(s) no balcão de Recepção na caixa assinalada.<br><br>Agradecemos a sua preferência e até breve.',
		checkout_text_w_items: 'Existem valores em aberto na sua reserva. Por favor, confirme se as contas estão corretas.',
		checkout_text_no_items: 'Faça o seu Check-Out de modo rápido e simples. Clique no botão abaixo.',
		checkout_warning: 'Por favor dirija-se ao balcão de receção para efetuar o Check-Out.',
		checkout_warning_w_rejected: 'Por favor dirija-se ao balcão de receção para verificar a sua conta.',
		client_account_sentence: 'Confirme na listagem abaixo os seus consumos durante a estadia.',
		confirmed_account_msg: 'Confirmação registada com sucesso.',
		discount: 'Desconto',
		checkout_done: 'Opção disponível apenas quando existe uma estadia a decorrer.',
		appointments: 'Marcações',
		animation: 'Animação',
		laundry: 'Lavandaria',
		associate_rsv: 'Pretendo juntar a minha marcação a outra marcação já existente.',
		rsv_number: 'Nº Reserva',
		your_rsv: 'A Sua Reserva',
		your_next_rsv: 'A Sua Próxima Reserva',
		room_number: 'Nº Quarto',
		rsv_succed: 'Marcação registada com sucesso.',
		str_hour_schedule: 'Das {start_time} às {end_time}',
		bookings_no_items: 'Não existem reservas registadas.',
		my_appointments: 'Minhas Reservas',
		people_n: 'Nº Pessoas',
		service: 'Serviço',
		service_type: 'Tipo de Serviço',
		horario: 'Horário',
		horarios: 'Horários',
		space: 'Espaço',
		space_type: 'Tipo de Espaço',
		availability: 'Disponibilidade',
		type_of: 'Tipo de',
		dish: 'Prato',
		newa: 'Nova',
		newo: 'Novo',
		cancelled: 'Cancelado',
		aviso: 'Aviso',
		yes: 'Sim',
		no: 'Não',
		my_bookings_sentence: 'Consulte as suas marcações na listagem abaixo.',
		Entretenimento: 'Entretenimento',
		Noticiass: 'Noticias',
		Eventos: 'Eventos',
		Eventoss: 'Eventos',
		payment_msg: 'Pode realizar o pagamento do seus consumos agora ou mais tarde na recepção do hotel.',
		consult: 'Consultar',
		no_spaces: 'Não é possível realizar marcações. Por favor, contacte a recepção.',
		no_shedules: 'Não existem horários disponíveis. Por favor, contacte a recepção.',
		booking_removed: 'Marcação removida com sucesso.',
		Configuration: 'Configuração',
		error: 'Erro',
		VilaGaleSTAR: 'Vila Galé STAR',
		Inovar_Motivar: 'Inovar Motivar',
		Configuration: 'Configuração',
		check_cartas_login: 'Pretende consultar as nossas cartas?<br>Clique',
		check_entertainment_login: 'Pretende consultar os nossos programas de entretenimento?<br>Clique',
		here: 'aqui',
		Parcerias: 'Parcerias',
		Parceriass: 'Parcerias',
		Categorias: 'Categorias',
		Todos: 'Todos',
		payment_success : 'Pagamento efectuado com sucesso',
		hotel: 'Hotel',
		payment_pending : 'O pagamento está pendente de autorização. Por favor, aceda à aplicação e autorize o pagamento.',
		no_reservations_available: 'Não existem reservas disponíveis.',
		recover_1: 'Os seus dados de acesso foram enviados para o e-mail',
		recover_2: '. Se não recebeu o nosso e-mail (verifique em todas as pastas, incluindo a pasta Spam), clique',
		recover_3: 'para que o email seja enviado novamente.',
		just_a_second: 'Só um segundo...',
		recover_aqui: 'aqui',
		contact: 'Ocorreu um erro. Por favor entre em contacto connosco.',
		recover_title: 'Recuperação de senha',
		erro_date: 'Erro com a data selecionada.',
		new_password: 'Nova Password',
		new_password_desc: 'É necessário alterar a sua password antes de entrar no ',
		password_changed: 'A nova password foi registada com sucesso.',
		submeter: 'Submeter',
		missing_pass: 'O campo “Password” é obrigatório.',
		missing_conf_pass: 'O campo “Confirmar Password” é obrigatório.',
		pass_not_match: 'Os campos “Password” e “Confirmar Password” não estão iguais.',
		tipo_de_marcacao: 'Tipo de Marcação',
		tipo_de_espaco: 'Tipo de Espaço',
		data_do_registo: 'Data do Registo',
		mesas: 'Mesas',
		n_quarto: 'Nº Quarto',
		grupo: 'Grupo',
		n_presenças: 'Nº Presenças',
		registado_por: 'Registado Por',
		observacoes: 'Observações',
		nome: 'Nome',
		n_grupo: 'Nº Grupo',
		regime: 'Regime',
		n_presencas: 'Nº Presenças',
		ver: 'Ver',
		n_presencas_registado: 'Nº de presenças registado com sucesso.',
		erro_numero_distribuicao_reserva: 'Erro - numero da distribuição da reserva',
		erro_numero_pessoas: 'Erro - numero de pessoas',
		erro_guardar_n_presencas: 'Erro ao guardar o Nº Presenças.',
		Pesquisar: 'Pesquisar',
		obrigatorio_inserir_n_reserva_n_quarto: 'É obrigatório inserir o Nº de Reserva ou o Nº de Quarto.',
		sair: 'Sair',
		Limpar: 'Limpar',
		Grupos: 'Grupos',
		Passante: 'Passante',
		Reserva: 'Reserva',
		Pessoas: 'Pessoa(s)',
		Houve_um_colega_que_se_destacou: 'Houve um colega que se destacou?',
		Nomeia_o_para_o_Vila_Gale_Star: 'Nomeia-o para o Vila Galé Star!',
		Todos_os_meses_e_eleito_um_vencedor: 'Todos os meses é eleito um vencedor!',
		Quem_sabe_se_tu_nao_seras_o_proximo: 'Quem sabe se tu não serás o próximo!',
		Ano: 'Ano',
		Trimestre: 'Trimestre',
		Mes: 'Mês',
		Portugal: 'Portugal',
		E_a_cada_3_meses: 'E, a cada 3 meses,',
		havera_uma_decisao_com_premio: ' haverá uma decisão com prémio!',
		Quem_sabe_se_es_o_proximo: 'Quem sabe se és o próximo!',
		Faz_nos_Brilhar: 'Faz-nos Brilhar!',
		Regulamento: 'Regulamento',
		Nomear: 'Nomear',
		Finalidade: 'Finalidade',
		O_programa_visa_evidenciar_o_merito_do_desempenho_dos: 'O programa visa evidenciar o mérito do desempenho dos colaboradores, num modelo de decisão participativa por parte dos restantes membros da unidade ou departamento.',
		Metodo: 'Método',
		O_programa_divide_se_em_4_fases: 'O programa divide-se em 4 fases:',
		Mensal: 'Mensal',
		votacao: 'Votação',
		a_votacao_doa_vg_star_mensal_e_feita_atraves_das: 'A votação do(a) VG STAR Mensal é feita através das nomeações dos colegas nosformulários do placard do ISL, My Vila Galé e ERP, dos clientes através dosquestionários internos de satisfação e outras plataformas digitais e em reunião dechefias.',
		eleicao: 'Eleição',
		a_eleicao_do_vg_star_mensal_e_feita_atraves_da: 'A eleição do VG STAR Mensal é feita através da ponderação das nomeações dos colegas (40%), da menção dos clientes (40%) e de reunião de chefias (20%). O(A)vencedor(a) deverá ser comunicado no último dia de cada mês. No mês de dezembro não haverá lugar a eleição.',
		premios: 'Prémios',
		ao_vencedor_do_vg_star_mensal_e_atribuido: 'Ao(à) vencedor(a) do VG STAR Mensal é atribuído:',
		o_premio_de_5000_em_vale_valor_ivla_gale_carregados: 'O prémio de 50,00€ em Vale Valor Vila Galé, carregados no profile em ERP;',
		sera_divulgadoa_oa_vencedora_atraves: 'Será divulgado(a) o(a) vencedor(a) através do Placard do ISL.',
		criterios_de_nao_eleicao: 'Critérios de NÃO eleição',
		falta_injustificada_no_mes_da_nomeacao: 'Falta injustificada no mês da nomeação;',
		advertencia_por_escrito: 'Advertência por escrito;',
		reclamacoes_com_o_seu_nome: 'Reclamações com o seu nome;',
		ter_sido_eleito_a_no_presente_trimestre: 'Ter sido eleito(a) no presente trimestre.',
		trimestral: 'Trimestral',
		oa_vg_star_trimestral_sera_uma_dosas_colegas: 'O(a) VG STAR Trimestral será um(a) dos(as) colegas da mesma unidade vencedores do VG STAR Mensal nos 3 meses anteriores.',
		a_eleicao_do_vg_star_trimestral_e_feita_atraves: 'A eleição do VG STAR Trimestral é feita através de reunião de chefias considerando os 3 colegas vencedores nos meses anteriores. O(A) vencedor(a) será comunicado até ao dia 15 do mês seguinte ao do final do trimestre, à exceção do mês de dezembro. (15 de abril, 15 de julho, 15 de outubro, 5 de dezembro).',
		ao_vencedora_do_vg_star_trimestral_sao: 'Ao(à) vencedor(a) do VG STAR Trimestral são atribuídos os prémios:',
		em_vale_valor_carregados_no_profile_em_erp_50: '50,00€ em Vale Valor carregados no profile em ERP (a acumular com os 50,00€ carregados no VG Star Mensal);',
		badge_com_estrela_que_devera_ser_utilizado_durante: 'Badge com estrela que deverá ser utilizado durante todo o ano;',
		sera_divulgado_a_o_a_vencedor_a_para_os_clientes: 'Será divulgado(a) o(a) vencedor(a) para os clientes através da televisão da receção e do portal My Vila Galé.',
		falta_injustificada_no_trimestre: 'Falta injustificada no trimestre;',
		advertencia_por_escrito: 'Advertência por escrito;',
		atrasos_injustificados_no_trimestre: 'Atrasos injustificados no trimestre;',
		altercacoes: 'Altercações;',
		ter_sido_nomeado_vg_star_trimestre_no_presente_ano: 'Ter sido nomeado VG STAR (trimestre) no presente ano.',
		a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de: 'A eleição do VG SUPERSTAR Hotel é feita através de reunião de chefias até dia 05 de dezembro de cada ano. O(A) eleito(a) deverá ser um(a) dos(as) VG STAR dos 4 trimestres.',
		aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios: 'Ao(à) vencedor(a) do VG SUPERSTAR Hotel são atribuídos os prémios',
		em_vale_valor_carregados_no_profile_em_erp_100: '100,00€ em Vale Valor carregados no profile em ERP',
		um_cabaz_de_Natal_e_osas_vencedoresas_serão_anunciados: 'um cabaz de Natal e os(as) vencedores(as) serão anunciados na Festa de Natal',
		sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL: 'Será divulgado(a) o(a) vencedor(a) através do Placard do ISL e para os clientes através da televisão da receção e do portal My Vila Galé',
		todas_os_criterios_referidos_no_vg_star: 'Todos os critérios referidos no VG STAR;',
		nao_ter_sido_vencedora_do_vg_star: 'Não ter sido vencedor(a) do VG STAR.',
		Nacional: 'Nacional',
		oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos: 'O(a) VG SUPERSTAR Nacional é feita através da análise dos vencedores do VG SUPERSTAR de cada hotel',
		a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri: 'A eleição do VG SUPERSTAR Nacional é feita por um júri composto pela Direção de Operações, Administração e Direção Financeira.',
		ao_vencedor_do_vg_superstar_nacional_sao_atribuidos: 'Ao(à) vencedor(a) do VG SUPERSTAR Nacional são atribuídos os prémios',
		em_vale_valor_carregados_no_profile_em_erp_200: '200,00€ em Vale Valor carregados no profile em ERP;',
		oa_vencedora_sera_convidadoa_a_estar_presente: 'O(a) vencedor(a) será convidado(a) a estar presente na Convenção Anual do grupo e será mencionado(a) na E-feel Staff, My Vila Galé e no Whatsapp;',
		sera_divulgado_o_vencedor_para_os_clientes: 'Será divulgado(a) o(a) vencedor(a) para os clientes através da televisão da receção e do portal My Vila Galé.',
		todas_os_criterios_referidos_no_vg_star: 'Todas os critérios referidos no VG STAR;',
		nao_ter_sido_vencedor_a_do_vg_star: 'Não ter sido vencedor(a) do VG STAR.',
		Nenhum_colaborador_encontrado: 'Nenhum colaborador encontrado',
		O_campo_Colaborador_é_obrigatório: 'O campo Colaborador é obrigatório',
		O_campo_Motivo_é_obrigatório: 'O campo Motivo é obrigatório',
		Passou_o_limite_de_caracteres_para_o_campo_Motivo: 'Passou o limite de caracteres para o campo Motivo',
		Nomeação_registada_com_sucesso: 'Obrigado pela sua nomeação.',
		Este_mês_já_fez_uma_nomeação: 'Este mês já fez uma nomeação',
		SelecionarIdioma: 'Selecionar Idioma',
		Idioma: 'Idioma',
		Nova: 'Nova',
		Link: 'Link',
		Corporativo: 'Corporativo',
		PortuguêsPT: 'Português PT',
		PortuguêsBR: 'Português BR',
		O_tamanho_máximo_permitido_para_a_imagemé_de_200kb: 'O tamanho máximo permitido para a imagem é de 200kb',
		As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório: 'As dimensões da imagem devem ser 500px x 500px (obrigatório)',
		Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif: 'Imagens devem ser do tipo \'.jpg\', \'.jpeg\', \'.png\' ou \'.gif\'',
		O_campo_Idioma_é_obrigatório: 'O campo Idioma é obrigatório',
		O_campo_Hotel_é_obrigatório: 'O campo Hotel é obrigatório',
		Registo_criado_com_sucesso: 'Registo criado com sucesso',
		Ocorreu_um_erro_ao_criar_o_registo: 'Ocorreu um erro ao criar o registo',
		Registo_eliminado_com_sucesso: 'Registo eliminado com sucesso',
		Ocorreu_um_erro_ao_eliminar_o_registo: 'Ocorreu um erro ao eliminar o registo',
		INOVAR: 'INOVAR',
		MOTIVAR: 'MOTIVAR',
		Inovar_Motivar: 'Inovar Motivar',
		Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar: 'Participa no programa Inovar Motivar e habilita-te a ganhar 75€.',
		Vamos_contribuir_para_a_mudança_do_nosso_grupo: 'Vamos contribuir para a mudança do nosso grupo!',
		Inova_e_Ganha: 'Inova e Ganha!',
		Participar: 'Participar',
		O_programa_visa_incentivar_a_participação_de_todos_no: 'O programa visa incentivar a participação de todos no desenvolvimento da empresa, valorizando as suas ideias e sugestões, e criar um maior envolvimento e ligação entre todos os colaboradores e a Vila Galé.',
		As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada: 'As ideias ou sugestões recebidas até ao final de cada trimestre serão avaliadas por um VG LAB.',
		Para_participar_basta_preencher_o_formulário_em_papel:'Para participar basta preencher o formulário em papel ou online (ERP/ My Vila Galé).',
		As_ideias_apresentadas_serão_classificadas_em:'As ideias apresentadas serão classificadas em 3 critérios:',
		Relevantes_e_finalizadas_para_implementação_premiadas: 'Relevantes e finalizadas para implementação - premiadas;',
		Desenvolvimento_o_a_colaborador_a_será_convidado: 'Desenvolvimento - o(a) colaborador(a) será convidado(a) a melhorar a sua ideia de modo a que passe a ser exequível;',
		Não_relevantes: 'Não relevantes.',
		A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor: 'A(s) ideia(s) premiada(s) recebem um prémio no valor de 75€ em cartão Sonae ou 100€ em Vale Incentivo VG.',
		Fatores_eliminatórios_apenas_a_sugestão_ou_ideia: 'Fatores eliminatórios (apenas a sugestão ou ideia adequada aos mesmos possibilitará a sua nomeação):',
		Inovação_e_originalidade: 'Inovação e originalidade',
		Valor_acrescentado_para_a_empresa: 'Valor acrescentado para a empresa',
		Necessidade_de_implementação: 'Necessidade de implementação',
		Exequibilidade_operacional: 'Exequibilidade operacional',
		Método_de_implementação: 'Método de implementação',
		Custos_de_implementação: 'Custos de implementação',
		As_ideias_ou_sugestões_relevantes_não_serão_premiadas: 'As ideias ou sugestões relevantes não serão premiadas numa primeira etapa, contudo poderão ser após desenvolvimento por parte do(a) colaborador(a).',
		Em_caso_de_ideias_similares_apenas_uma_será_premiada:'Em caso de ideias similares, apenas uma será premiada. Obedecendo à seguinte ordem de eleição:',
		Mais_critérios_eliminatórios_adequados: 'Mais critérios eliminatórios adequados;',
		Custos_de_implementação_calculados: 'Custos de implementação calculados;',
		Data_de_submissão: 'Data de submissão.',
		Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir: 'Ao VG LAB avaliador reserva-se o direito de não atribuir prémios, caso não tenha sido apresentada qualquer ideia ou as ideias apresentadas não reúnam as condições para a atribuição dos prémios.',
		Colaborador: 'Colaborador',
		Motivo: 'Motivo',
		Assunto: 'Assunto',
		Categoria: 'Categoria',
		Descrição: 'Descrição',
		Ficheiro: 'Ficheiro',
		Imagem: 'Imagem',
		Tipo: 'Tipo',
		Não_foram_encontradas_cartas_para_o_hotel_selecionado: 'Não foram encontradas cartas para o hotel selecionado.',
		Menu: 'Menu',
		Directório: 'Directório',
		Marcação: 'Marcação',
		Capitulo: 'Capitulo',
		Erro_nos_subcapitulos: 'Erro nos subcapitulos.',
		Carta_copiada_com_sucesso: 'Carta copiada com sucesso.',
		Erro_a_gravar: 'Erro a gravar',
		O_campo_Hotel_é_obrigatório: 'O campo Hotel é obrigatório.',
		Deseja_mesmo_apagar: 'Deseja mesmo apagar?',
		Pretende_eliminar: 'Pretende eliminar',
		Erro_a_obter_hoteis: 'Erro a obter hoteis',
		Visivel: 'Visível',
		Nome_Impressão: 'Nome Impressão',
		Informação: 'Informação',
		moeda: 'moeda',
		Moeda: 'Moeda',
		armazem: 'armazem',
		Armazém: 'Armazém',
		Remover_Imagem: 'Remover Imagem',
		Adicionar_Imagem: 'Adicionar_Imagem',
		As_dimensões_da_imagem_devem_ser_800px_x_600px: 'As dimensões da imagem devem ser 800px x 600px (obrigatório).',
		Esta_carta_já_foi_registada: 'Esta carta já foi registada.',
		Registo_alterado_com_sucesso: 'Registo alterado com sucesso',
		Registo_criado_com_sucesso: 'Registo criado com sucesso.',
		Ocorreu_um_erro_ao_alterar_o_registo: 'Ocorreu um erro ao alterar o registo',
		Ocorreu_um_erro_ao_criar_o_registo: 'Ocorreu um erro ao criar o registo.',
		O_campo_Nome_é_obrigatório_no_idioma: 'O campo Nome é obrigatório no idioma',
		O_campo_Moeda_é_obrigatório: 'O campo Moeda é obrigatório.',
		O_campo_Armazém_é_obrigatório: 'O campo Armazém é obrigatório.',
		O_campo_Categoria_é_obrigatório: 'O campo Categoria é obrigatório.',
		Ocorreu_um_erro: 'Ocorreu um erro.',
		Artigo_de_Venda: 'Artigo de Venda',
		Este_menu_já_foi_registado: 'Este menu já foi registado.',
		Ordem_n: 'Ordem (º)',
		Adicionar: 'Adicionar',
		Não_foram_encontrados_capítulos: 'Não foram encontrados capítulos.',
		O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a:'O campo Ordem deve ser númerico e maior ou igual a 0.',
		O_campo_Nome_é_obrigatório: 'O campo Nome é obrigatório.',
		Medidas: 'Medidas',
		Artigo_de_Venda: 'Artigo de Venda',
		Atualizar: 'Atualizar',
		Não_foram_encontrados_subcapítulos: 'Não foram encontrados subcapítulos',
		Litro: 'Litro',
		Decilitro: 'Decilitro',
		Centilitro: 'Centilitro',
		Mililitro: 'Mililitro',
		Minuto: 'Minuto',
		Não_foram_encontrados_capítulos_para_o_idioma_seleccionado: 'Não foram encontrados capítulos para o idioma seleccionado.',
		O_campo_Quantidade_é_obrigatório: 'O campo Quantidade é obrigatório.',
		O_campo_Medida_é_obrigatório: 'O campo Medida é obrigatório.',
		O_campo_Preço_deve_ser_numérico: 'O campo Preço deve ser numérico.',
		O_campo_Preço_é_obrigatório_e_deve_ser_numérico: 'O campo Preço é obrigatório e deve ser numérico.',
		Não_foram_adicionadas_medidas: 'Não foram adicionadas medidas.',
		O_campo_Preço_é_obrigatório: 'O campo Preço é obrigatório.',
		Zonas: 'Zonas',
		Data_de_Validade: 'Data de Validade',
		Upload: 'Upload',
		Destaque: 'Destaque',
		Pública: 'Pública',
		Privada: 'Privada',
		Resposta1: '1 Resposta',
		Várias_Opções: 'Várias Opções',
		Resposta: 'Resposta',
		A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif: 'A imagem tem ser do tipo jpeg, jpg, png ou gif',
		O_ficheiro_tem_de_ser_um_pdf: 'O ficheiro tem de ser um pdf.',
		Lista_de_Notícias: 'Lista de Notícias',
		Autor: 'Autor',
		Detalhe: 'Detalhe',
		Data_Inicio: 'Data Inicio',
		Data_Fim: 'Data Fim',
		Evento_apagado: 'Evento apagado.',
		Deseja_mesmo_apagar_o_evento: 'Deseja mesmo apagar o evento?',
		Apagar: 'Apagar',
		O_evento_será_apagado_e_não_será_possível_recuperá_lo: 'O evento {name} será apagado e não será possível recuperá-lo.',
		Privado: 'Privado',
		Não_é_possível_visualizar_o_documento: 'Não é possível visualizar o documento.',
		Já_chegou_ao_limite_de_ficheiros: 'Já chegou ao limite de ficheiros.',
		Apenas_são_aceites_PDFs_documentos_Word_ou_imagens: 'Apenas são aceites PDFs, documentos Word ou imagens com formato jpeg, jpg ou png.',
		O_ficheiro_não_pode_ter_mais_de_10mb: 'O ficheiro não pode ter mais de 10mb.',
		O_campo_Assunto_é_obrigatório: 'O campo Assunto é obrigatório.',
		O_campo_Categoria_é_obrigatório: 'O campo Categoria é obrigatório.',
		O_campo_Descrição_é_obrigatório: 'O campo Descrição é obrigatório.',
		Passou_o_limite_de_caracteres_para_o_campo_Descrição: 'Passou o limite de caracteres para o campo Descrição.',
		Participação_registada_com_sucesso: 'Participação registrada com sucesso.',
		Este_directório_já_foi_registado: 'Este directório já foi registado.',
		Só_é_permitido_um_directório_por_hotel: 'Só é permitido um directório por hotel.',
		Ficheiros: 'Ficheiros',
		Data_de_Início: 'Data de Início',
		Data_de_Fim: 'Data de Fim',
		A_Data_de_Início_não_está_selecionada: 'A Data de Início não está selecionada.',
		A_Data_de_Fim_não_está_selecionada: 'A Data de Fim não está selecionada.',
		Titulo: 'Titulo',
	},
	// Lang PT




	// Lang BR
	br: {
		fromOurTradition: 'Da nossa Tradição',	
		description: 'Descrição',
		price: 'Preço',
		restaurantFood: 'Restaurante Val Moreira | Carta',
		restaurantDrinks: 'Restaurante Val Moreira | Bebidas',
		appetizers: 'Entradas',
		appetizer_one: 'Creme de espargos verdes, crocante de salpicão e cebolinho',
		appetizer_two: 'O nosso caldo verde',
		appetizer_three: 'Salada de queijo fresco, pêssego, presunto serrano e amêndoas',
		appetizer_four: 'Torricado de alheira de Lamego com ovo de codorniz',
		appetizer_five: 'Camarão em tempura, manga, chutney de kiwi, chili doce e rebentos de salada',
		dish_monday: 'Pastéis de massa tenra com arroz de feijão manteiga',
		dish_tuesday: 'Filetes de polvo com arroz de grelos',
		dish_wednesday: 'Arroz de pato à antiga',
		dish_thursday: 'Lombos de bacalhau à Margarida da Praça',
		dish_friday: 'Empada de caça com espinafres salteados',
		dish_saturday: 'Trutas do rio Cavado com presunto e batata cozida',
		dish_sunday: 'Cabrito assado com batata e grelos salteados',
		Cliente: 'Cliente',
		Orders: 'Room Service',
		account: 'Conta',
		Estadia: 'Estadia',
		Checkin: 'Check-In Online',
		vSelectNoResults: 'Sem resultados.',
		vSelectNoOptions: 'Sem opções disponíveis',
		EstadiasAnteriores: 'Estadias Anteriores',
		QuestionarioSatisfacao: 'Questionários',
		InstantFeedback: 'Feedback Instantâneo',
		Cartas: 'Cartas',
		Capitulo: 'Capitulo',
		Chapters: 'Capítulos',
		Subcapitulos: 'Subcapitulo',
		MenuSetup: 'Setup',
		Restauracao: 'Cartas',
		RestauranteValMoreiraComida: 'Restaurante Val Moreira | Comida',
		RestauranteValMoreiraBebidas: 'Restaurante Val Moreira | Bebidas',
		BarValMoreira: 'Bar Val Moreira',	
		PequenoAlmoco: 'Pequeno Almoço',
		ChaDas5: 'Chá das 5',
		MenuNep: 'Menu NEP',
		VinhosAdega: 'Vinhos / Adega',
		Gins: 'Gins',
		Servicos: 'Serviços',
		Piscina: 'Piscina',
		Lavandaria: 'Lavanderia',
		Minibar: 'Minibar',
		VinhosAzeites: 'Vinhos / Azeites',
		RoomService: 'Serviço de Quartos',
		Spa: 'Spa',
		DirectorioAZ: 'Directório A-Z',
		IvaCorrente: 'IVA Incluído à taxa corrente.',
		LivroReclamacoes: 'Este estabelecimento dispõe de livro de reclamações.',
		PrevencaoAlergias: 'Para prevenção de potenciais alergias, existe ficha técnica com a descrição dos ingredientes utilizados. Nenhum prato, produto alimentar ou bebida, incluindo o couvert, pode ser cobrado se não for solicitado pelo cliente ou por este for inutilizado.',
		PrevencaoIncendios: 'Prevenção de Incêndios',
		EstadiaActual: 'A Sua Estadia',
		ContaDeQuarto: 'A Sua Conta Atual',
		pontoDeVenda: 'Ponto de Venda',
		dataHora: 'Data e Hora',
		artigoFactura: 'Artigo de Fatura',
		amount: 'Valor',
		billConfirmation: 'Confirmado',
		SuasEstadiasAnteriores: "As suas estadias anteriores",
		WakeUp: "Serviço Despertar",
		naoPerturbar: "Serviço Não Perturbar",
		suporte: "Pedido de Manutenção",
		Produtos: "Produtos",
		Welcome_M: "Bem-vindo",
		Welcome_F: "Bem-vinda",
		gerirConteudos: "Conteúdos",
		gerirUtilizadores: "Permissões",
		pesquisarUtilizador: "Pesquisar Utilizador",
		Administracao: "Administração",
		editUserRole: "Editar permissão",
		insertUserId: "Email, Id ou Nome",
		Gravar: "Salvar",
		roleActual: "Permissão",
		roleSuccess: "Nivel alterado com sucesso.",
		gerirConteudoMain: "Gerir Conteúdos da Página Principal",
		directorio: "Diretório",
		main_page: "Homepage",
		edit_hotel: "Escolha o Hotel para editar: ",
		current_hotel: "Hotel Atual",
		select_hotel: "Escolher Hotel",
		corporate_images: "Imagens Corporativas",
		password: 'Senha',
		register: 'Registrar',
		user: 'Usuário',
		user_email: 'Usuário ou Email',
		invalid_credentials: 'Credenciais inválidas',
		attention: 'Atenção.',
		mandatory_user: 'O campo usuário é obrigatório.',
		mandatory_password: 'O campo senha é obrigatório.',
		login_password: 'Os campos usuário e senha são obrigatórios.',
		error_password: 'Password incorreto',
		added_item_to_cart: 'Item adicionado ao carrinho com sucesso.',
		order_placed: 'Seu pedido foi realizado com sucesso.',
		success: 'Sucesso.',
		order_error: 'Erro ao processar pedido, por favor tente novamente.',
		user_not_found: "Não foram encontrados registros.",
		empty_search_filed: 'O campo de pesquisa deve estar preenchido',
		en: 'Inglês',
		pt: 'Português',
		br: 'Português',
		de: 'Alemão',
		fr: 'Francês',
		es: 'Espanhol',
		dont_show_popup: 'Não mostrar esta mensagem novamente',
		empty_feedback: 'Existem perguntas sem resposta selecionada.',
		feedback_comments: 'Comentários (opcional)',
		feedback_thanks: 'Obrigado pelo seu feedback.',
		noFeedback: 'Feedback instantâneo indisponível porque não existe uma estadia a decorrer.',
		submit: "Submeter",
		long_comment_feedback: "Seu comentário ultrapassa os limites de carateres.",
		corporate_banners: 'Grupo Vila Galé',
		changeRole: 'Registro alterado com sucesso.',
		addRole: 'Registro criado com sucesso.',
		removeRole: 'Registro removido com sucesso.',
		instantFeedback: 'Feedback instantâneo',
		noAvailableFeedback: 'Feedback instantâneo indisponível porque não existe uma estadia a decorrer.',
		legalNotice: 'Aviso Legal',
		legalNoticeUrl: 'https://www.vilagale.com/pt/aviso-legal',
		privacyPolicy: 'Politica de Privacidade',
		privacyPolicyUrl: 'https://www.vilagale.com/pt/politica-de-privacidade',
		complaintsBook: 'Livro de Reclamações',
		complaintsBookUrl: 'https://www.livroreclamacoes.pt/inicio/',
		Noticias: 'Notícias',
		Carta: 'Carta',
		noCheckin: 'Não existem reservas para realizar o Check-In Online',
		noSurvey: 'Não existem questionários para responder.',
		questionnaires: 'Questionários',
		reservation: 'Reserva',
		answer: 'Responder',
		open: 'Abrir',
		CartasSide: 'Cartas',
		noOrders: 'Não existem pedidos realizados.',
		emptyCart: "Seu carrinho está vazio",
		returnButton: 'Voltar',
		description: 'Descrção',
		noMenus: 'Não existem cartas disponíveis.',
		noItems: 'Itens não disponíveis.',
		noChapter: 'Carta não disponível.',
		noDirectory: 'Directório A-Z não disponível',
		noDirectoryLang: 'Directório A-Z não disponível para este idioma.',
		noItemsAvailable: 'Itens não disponíveis.',
		quantity: 'Quantidade',
		noItemsInCart: 'Não existem itens no seu carrinho.',
		seeMenus: 'Var Cartas',
		save_item_rejected: 'Guardar',
		finishOrder: 'Confirmar',
		remove: 'Remover',
		notes: 'Observações',
		noStay: 'Room Service indisponível porque não existe uma estadia a decorrer.',
		placedOrders: 'Pedidos Realizados',
		cancels: 'Cancelar',
		yourCart: 'Seu carrinho.',
		noPlacedOrders: 'Não existem pedidos realizados.',
		revocerPassword: 'Esqueceu a senha?',
		item: 'Artigo',
		local: 'Local',
		date: 'Data',
		account_quantity: 'Qtd.',
		value: 'Valor',
		reject: 'Rejeitar',
		Noticia: 'Notícia',
		Questionario: 'Questionário',
		Voltar: 'Voltar',
		Comentario: 'Comentário',
		Comentar: 'Comentar',
		Ver_mais: 'Ver Mais',
		Saber_mais: 'Saber mais',
		nao_foram_encontradas_noticias: 'Não foram encontradas notícias.',
		Todas: 'Todas',
		Comidas: 'Comidas',
		Bebidas: 'Bebidas',
		Outras: 'Outras',
		Filtro: 'Filtro',
		Pesquisa: 'Pesquisa',
		Perfil: 'Perfil',
		Clube: 'Clube',
		send_account_info: 'Enviar',
		reject_items_question: 'Indique-nos o motivo.',
		approved : "Aprovado",
		to_send : "Por Enviar",
		rejected_at : "Rejeitado a",
		rejected : "Rejeitado",
		status : "Estado",
		payments: "Pagamento",
		pago    : "Pago",
		client_accounts: 'Client Accounts',
		client_account: 'Conta de Cliente',
		end_payment : 'Finalizar Pagamento',
		account_no_items : 'Não existem artigos nesta conta',
		Informations: 'Informações',
		Nao_existem_conteudos_hotel_selecionado: 'Não existem conteúdos para o hotel selecionado.',
		Selecione_hotel_ver_conteúdo: 'Selecione um hotel para ver o seu conteúdo.',
		success_rsv_checkout : 'Check-out bem sucedido',
		account_no_items : 'Não existem consumos registrados.',
		success_rsv_checkout : 'O seu Check-Out foi realizado com sucesso.<br>Por favor deixe a(s) chave(s) no balcão de Recepção na caixa assinalada.<br><br>Agradecemos a sua preferência e até breve.',
		checkout_text_w_items: 'Existem valores em aberto na sua reserva. Por favor, confirme se está tudo correto.',
		checkout_text_no_items: 'Faça o seu Check-Out de modo rápido e simples. Clique no botão abaixo.',
		checkout_warning: 'Por favor dirija-se ao balcão de receção para efetuar o Check-Out.',
		checkout_warning_w_rejected: 'Por favor dirija-se ao balcão de receção para verificar a sua conta.',
		client_account_sentence: 'Confirme na listagem abaixo os seus consumos durante a estadia.',
		confirmed_account_msg: 'Confirmação registrada com sucesso.',
		discount: 'Desconto',
		checkout_done: 'Opção disponível apenas quando existe uma estadia a decorrer.',
		appointments: 'Marcações',
		animation: 'Animação',
		laundry: 'Lavandaria',
		associate_rsv: 'Pretendo juntar a minha marcação a outra marcação já existente.',
		rsv_number: 'Nº Reserva',
		your_next_rsv: 'A Sua Próxima Reserva',
		your_rsv: 'A Sua Reserva',
		room_number: 'Nº Quarto',
		rsv_succed: 'Marcação registrada com sucesso.',
		str_hour_schedule: 'Das {start_time} às {end_time}',
		bookings_no_items: 'Não existem reservas registradas.',
		my_appointments: 'Minhas Reservas',
		people_n: 'Nº Pessoas',
		service: 'Serviço',
		service_type: 'Tipo de Serviço',
		horario: 'Horário',
		horarios: 'Horários',
		space: 'Espaço',
		space_type: 'Tipo de Espaço',
		availability: 'Disponibilidade',
		type_of: 'Tipo de',
		dish: 'Prato',
		newa: 'Nova',
		newo: 'Novo',
		cancelled: 'Cancelado',
		aviso: 'Aviso',
		yes: 'Sim',
		no: 'Não',
		my_bookings_sentence: 'Consulte as suas marcações na listagem abaixo.',
		Entretenimento: 'Entretenimento',
		Noticiass: 'Noticias',
		Eventos: 'Events',
		Eventoss: 'Eventos',
		payment_msg: 'Pode realizar o pagamento do seus consumos agora ou mais tarde na recepção do hotel.',
		consult: 'Consultar',
		no_spaces: 'Não é possível realizar marcações. Por favor, contacte a recepção.',
		no_shedules: 'Não existem horários disponíveis. Por favor, contacte a recepção.',
		booking_removed: 'Marcação removida com sucesso.',
		Configuration: 'Configuração',
		error: 'Erro',
		VilaGaleSTAR: 'Vila Galé STAR',
		Inovar_Motivar: 'Inovar Motivar',
		check_cartas_login: 'Pretende consultar os nossos cardápios?<br>Clique',
		check_entertainment_login: 'Pretende consultar a nossa programação de entretenimento?<br>Clique',
		here: 'aqui',		
		Parcerias: 'Parcerias',
		Parceriass: 'Parcerias',
		Categorias: 'Categorias',
		Todas: 'Todas',
		Todos: 'Todos',
		payment_success : 'Pagamento efectuado com sucesso',
		horarios : 'Horário',
		hotel: 'Hotel',
		payment_pending : 'O pagamento está pendente de autorização. Por favor, aceda à aplicação e autorize o pagamento.',
		no_reservations_available: 'Não existem reservas disponíveis.',
		recover_1: 'Os seus dados de acesso foram enviados para o e-mail',
		recover_2: '. Se não recebeu o nosso e-mail (verifique em todas as pastas, incluindo a pasta Spam), clique',
		recover_3: 'para que o email seja enviado novamente.',
		just_a_second: 'Só um segundo...',
		recover_aqui: 'aqui',
		contact: 'Ocorreu um erro. Por favor entre em contacto connosco.',
		recover_title: 'Recuperação de senha',
		erro_date: 'Erro com a data selecionada.',
		new_password: 'Nova Password',
		new_password_desc: 'É necessário alterar a sua password antes de entrar no ',
		password_changed: 'A nova password foi registrada com sucesso.',
		submeter: 'Submeter',
		missing_pass: 'O campo “Password” é obrigatório.',
		missing_conf_pass: 'O campo “Confirmar Password” é obrigatório.',
		pass_not_match: 'Os campos “Password” e “Confirmar Password” não estão iguais.',
		tipo_de_marcacao: 'Tipo de Marcação',
		tipo_de_espaco: 'Tipo de Espaço',
		data_do_registo: 'Data do Registro',
		mesas: 'Mesas',
		n_quarto: 'Nº Quarto',
		grupo: 'Grupo',
		n_presenças: 'Nº Presenças',
		registado_por: 'Registrado Por',
		observacoes: 'Observações',
		nome: 'Nome',
		n_grupo: 'Nº Grupo',
		regime: 'Regime',
		n_presencas: 'Nº Presenças',
		ver: 'Ver',
		n_presencas_registado: 'Nº de presenças registrado com sucesso.',
		erro_numero_distribuicao_reserva: 'Erro - numero da distribuição da reserva',
		erro_numero_pessoas: 'Erro - numero de pessoas',
		erro_guardar_n_presencas: 'Erro ao guardar o Nº Presenças.',
		Pesquisar: 'Pesquisar',
		obrigatorio_inserir_n_reserva_n_quarto: 'É obrigatório inserir o Nº de Reserva ou o Nº de Quarto.',
		sair: 'Sair',
		Limpar: 'Limpar',
		Grupos: 'Grupos',
		Passante: 'Passante',
		Reserva: 'Reserva',
		Pessoas: 'Pessoa(s)',
		Houve_um_colega_que_se_destacou: 'Houve um colega que se destacou?',
		Nomeia_o_para_o_Vila_Gale_Star: 'Nomeia-o para o Vila Galé Star!',
		Todos_os_meses_e_eleito_um_vencedor: 'Todos os meses é eleito um vencedor!',
		Quem_sabe_se_tu_nao_seras_o_proximo: 'Quem sabe se tu não serás o próximo!',
		Ano: 'Ano',
		Trimestre: 'Trimestre',
		Mes: 'Mês',
		Portugal: 'Portugal',
		E_a_cada_3_meses: 'E, a cada 3 meses,',
		havera_uma_decisao_com_premio: ' haverá uma decisão com prémio!',
		Quem_sabe_se_es_o_proximo: 'Quem sabe se és o próximo!',
		Faz_nos_Brilhar: 'Faz-nos Brilhar!',
		Regulamento: 'Regulamento',
		Nomear: 'Nomear',
		Finalidade: 'Finalidade',
		O_programa_visa_evidenciar_o_merito_do_desempenho_dos: 'O programa visa evidenciar o mérito do desempenho dos colaboradores, num modelo de decisão participativa por parte dos restantes membros da unidade ou departamento.',
		Metodo: 'Método',
		O_programa_divide_se_em_4_fases: 'O programa divide-se em 4 fases:',
		Mensal: 'Mensal',
		votacao: 'Votação',
		a_votacao_doa_vg_star_mensal_e_feita_atraves_das: 'A votação do(a) VG STAR Mensal é feita através das nomeações dos colegas nosformulários do placard do ISL, My Vila Galé e ERP, dos clientes através dosquestionários internos de satisfação e outras plataformas digitais e em reunião de chefias.',
		eleicao: 'Eleição',
		a_eleicao_do_vg_star_mensal_e_feita_atraves_da: 'A eleição do VG STAR Mensal é feita através da ponderação das nomeações dos colegas (40%), da menção dos clientes (40%) e de reunião de chefias (20%). O(A)vencedor(a) deverá ser comunicado no último dia de cada mês. No mês de dezembronão haverá lugar a eleição.',
		premios: 'Prémios',
		ao_vencedor_do_vg_star_mensal_e_atribuido: 'Ao(à) vencedor(a) do VG STAR Mensal é atribuído:',
		o_premio_de_5000_em_vale_valor_ivla_gale_carregados: 'O prémio de 50,00€ em Vale Valor Vila Galé, carregados no profile em ERP;',
		sera_divulgadoa_oa_vencedora_atraves: 'Será divulgado(a) o(a) vencedor(a) através do Placard do ISL.',
		criterios_de_nao_eleicao: 'Critérios de NÃO eleição',
		falta_injustificada_no_mes_da_nomeacao: 'Falta injustificada no mês da nomeação;',
		advertencia_por_escrito: 'Advertência por escrito;',
		reclamacoes_com_o_seu_nome: 'Reclamações com o seu nome;',
		ter_sido_eleito_a_no_presente_trimestre: 'Ter sido eleito(a) no presente trimestre.',
		trimestral: 'Trimestral',
		oa_vg_star_trimestral_sera_uma_dosas_colegas: 'O(a) VG STAR Trimestral será um(a) dos(as) colegas da mesma unidade vencedores do VG STAR Mensal nos 3 meses anteriores.',
		a_eleicao_do_vg_star_trimestral_e_feita_atraves: 'A eleição do VG STAR Trimestral é feita através de reunião de chefias considerando os 3 colegas vencedores nos meses anteriores. O(A) vencedor(a) será comunicado até ao dia 15 do mês seguinte ao do final do trimestre, à exceção do mês de dezembro. (15 de abril, 15 de julho, 15 de outubro, 5 de dezembro).',
		ao_vencedora_do_vg_star_trimestral_sao: 'Ao(à) vencedor(a) do VG STAR Trimestral são atribuídos os prémios:',
		em_vale_valor_carregados_no_profile_em_erp_50: '50,00€ em Vale Valor carregados no profile em ERP (a acumular com os 50,00€ carregados no VG Star Mensal);',
		badge_com_estrela_que_devera_ser_utilizado_durante: 'Badge com estrela que deverá ser utilizado durante todo o ano;',
		sera_divulgado_a_o_a_vencedor_a_para_os_clientes: 'Será divulgado(a) o(a) vencedor(a) para os clientes através da televisão da receção e do portal My Vila Galé.',
		falta_injustificada_no_trimestre: 'Falta injustificada no trimestre;',
		advertencia_por_escrito: 'Advertência por escrito;',
		atrasos_injustificados_no_trimestre: 'Atrasos injustificados no trimestre;',
		altercacoes: 'Altercações;',
		ter_sido_nomeado_vg_star_trimestre_no_presente_ano: 'Ter sido nomeado VG STAR (trimestre) no presente ano.',
		a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de: 'A eleição do VG SUPERSTAR Hotel é feita através de reunião de chefias até dia 05 de dezembro de cada ano. O(A) eleito(a) deverá ser um(a) dos(as) VG STAR dos 4 trimestres.',
		aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios: 'Ao(à) vencedor(a) do VG SUPERSTAR Hotel são atribuídos os prémios',
		em_vale_valor_carregados_no_profile_em_erp_100: '100,00€ em Vale Valor carregados no profile em ERP',
		um_cabaz_de_Natal_e_osas_vencedoresas_serão_anunciados: 'um cabaz de Natal e os(as) vencedores(as) serão anunciados na Festa de Natal',
		sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL: 'Será divulgado(a) o(a) vencedor(a) através do Placard do ISL e para os clientes através da televisão da receção e do portal My Vila Galé',
		todas_os_criterios_referidos_no_vg_star: 'Todas os critérios referidos no VG STAR;',
		nao_ter_sido_vencedora_do_vg_star: 'Não ter sido vencedor(a) do VG STAR.',
		Nacional: 'Nacional',
		oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos: 'O(a) VG SUPERSTAR Nacional é feita através da análise dos vencedores do VG SUPERSTAR de cada hotel',
		a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri: 'A eleição do VG SUPERSTAR Portugal é feita por um júri composto pela Direção de Operações, Administração e Direção Financeira.',
		ao_vencedor_do_vg_superstar_nacional_sao_atribuidos: 'Ao(à) vencedor(a) do VG SUPERSTAR Nacional são atribuídos os prémios',
		em_vale_valor_carregados_no_profile_em_erp_200: '200,00€ em Vale Valor carregados no profile em ERP;',
		oa_vencedora_sera_convidadoa_a_estar_presente: 'O(a) vencedor(a) será convidado(a) a estar presente na Convenção Anual do grupo e será mencionado(a) na E-feel Staff, My Vila Galé e no Whatsapp;',
		sera_divulgado_o_vencedor_para_os_clientes: 'Será divulgado(a) o(a) vencedor(a) para os clientes através da televisão da receção e do portal My Vila Galé.',
		todas_os_criterios_referidos_no_vg_star: 'Todas os critérios referidos no VG STAR;',
		nao_ter_sido_vencedor_a_do_vg_star: 'Não ter sido vencedor(a) do VG STAR.',
		Nenhum_colaborador_encontrado: 'Nenhum colaborador encontrado',
		O_campo_Colaborador_é_obrigatório: 'O campo Colaborador é obrigatório',
		O_campo_Motivo_é_obrigatório: 'O campo Motivo é obrigatório',
		Passou_o_limite_de_caracteres_para_o_campo_Motivo: 'Passou o limite de caracteres para o campo Motivo',
		Nomeação_registada_com_sucesso: 'Obrigado pela sua nomeação.',
		Este_mês_já_fez_uma_nomeação: 'Este mês já fez uma nomeação',
		SelecionarIdioma: 'Selecionar Idioma',
		Idioma: 'Idioma',
		Nova: 'Nova',
		Link: 'Link',
		Corporativo: 'Corporativo',
		PortuguêsPT: 'Português PT',
		PortuguêsBR: 'Português BR',
		O_tamanho_máximo_permitido_para_a_imagemé_de_200kb: 'O tamanho máximo permitido para a imagem é de 200kb',
		As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório: 'As dimensões da imagem devem ser 500px x 500px (obrigatório)',
		Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif: 'Imagens devem ser do tipo \'.jpg\', \'.jpeg\', \'.png\' ou \'.gif\'',
		O_campo_Idioma_é_obrigatório: 'O campo Idioma é obrigatório',
		O_campo_Hotel_é_obrigatório: 'O campo Hotel é obrigatório',
		Registo_criado_com_sucesso: 'Registro criado com sucesso',
		Ocorreu_um_erro_ao_criar_o_registo: 'Ocorreu um erro ao criar o registro',
		Registo_eliminado_com_sucesso: 'Registo eliminado com sucesso',
		Ocorreu_um_erro_ao_eliminar_o_registo: 'Ocorreu um erro ao eliminar o registro',
		INOVAR: 'INOVAR',
		MOTIVAR: 'MOTIVAR',
		Inovar_Motivar: 'Inovar Motivar',
		Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar: 'Participa no programa Inovar Motivar e habilita-te a ganhar 75€.',
		Vamos_contribuir_para_a_mudança_do_nosso_grupo: 'Vamos contribuir para a mudança do nosso grupo!',
		Inova_e_Ganha: 'Inova e Ganha!',
		Participar: 'Participar',
		O_programa_visa_incentivar_a_participação_de_todos_no: 'O programa visa incentivar a participação de todos no desenvolvimento da empresa, valorizando as suas ideias e sugestões, e criar um maior envolvimento e ligação entre todos os colaboradores e a Vila Galé.',
		As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada: 'As ideias ou sugestões recebidas até ao final de cada trimestre serão avaliadas por um VG LAB.',
		Para_participar_basta_preencher_o_formulário_em_papel:'Para participar basta preencher o formulário em papel ou online (ERP/ My Vila Galé).',
		As_ideias_apresentadas_serão_classificadas_em:'As ideias apresentadas serão classificadas em 3 critérios:',
		Relevantes_e_finalizadas_para_implementação_premiadas: 'Relevantes e finalizadas para implementação - premiadas;',
		Desenvolvimento_o_a_colaborador_a_será_convidado: 'Desenvolvimento - o(a) colaborador(a) será convidado(a) a melhorar a sua ideia de modo a que passe a ser exequível;',
		Não_relevantes: 'Não relevantes.',
		A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor: 'A(s) ideia(s) premiada(s) recebem um prémio no valor de 75€ em cartão Sonae ou 100€ em Vale Incentivo VG.',
		Fatores_eliminatórios_apenas_a_sugestão_ou_ideia: 'Fatores eliminatórios (apenas a sugestão ou ideia adequada aos mesmos possibilitará a sua nomeação):',
		Inovação_e_originalidade: 'Inovação e originalidade',
		Valor_acrescentado_para_a_empresa: 'Valor acrescentado para a empresa',
		Necessidade_de_implementação: 'Necessidade de implementação',
		Exequibilidade_operacional: 'Exequibilidade operacional',
		Método_de_implementação: 'Método de implementação',
		Custos_de_implementação: 'Custos de implementação',
		As_ideias_ou_sugestões_relevantes_não_serão_premiadas: 'As ideias ou sugestões relevantes não serão premiadas numa primeira etapa, contudo poderão ser após desenvolvimento por parte do(a) colaborador(a).',
		Em_caso_de_ideias_similares_apenas_uma_será_premiada:'Em caso de ideias similares, apenas uma será premiada. Obedecendo à seguinte ordem de eleição:',
		Mais_critérios_eliminatórios_adequados: 'Mais critérios eliminatórios adequados;',
		Custos_de_implementação_calculados: 'Custos de implementação calculados;',
		Data_de_submissão: 'Data de submissão.',
		Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir: 'Ao VG LAB avaliador reserva-se o direito de não atribuir prémios, caso não tenha sido apresentada qualquer ideia ou as ideias apresentadas não reúnam as condições para a atribuição dos prémios.',
		Colaborador: 'Colaborador',
		Motivo: 'Motivo',
		Assunto: 'Assunto',
		Categoria: 'Categoria',
		Descrição: 'Descrição',
		Ficheiro: 'Ficheiro',
		Imagem: 'Imagem',
		Tipo: 'Tipo',
		Não_foram_encontradas_cartas_para_o_hotel_selecionado: 'Não foram encontradas cartas para o hotel selecionado.',
		Menu: 'Menu',
		Directório: 'Directório',
		Marcação: 'Marcação',
		Capitulo: 'Capitulo',
		Erro_nos_subcapitulos: 'Erro nos subcapitulos.',
		Carta_copiada_com_sucesso: 'Carta copiada com sucesso.',
		Erro_a_gravar: 'Erro a gravar',
		O_campo_Hotel_é_obrigatório: 'O campo Hotel é obrigatório.',
		Deseja_mesmo_apagar: 'Deseja mesmo apagar?',
		Pretende_eliminar: 'Pretende eliminar',
		Erro_a_obter_hoteis: 'Erro a obter hoteis',
		Visivel: 'Visível',
		Nome_Impressão: 'Nome Impressão',
		Informação: 'Informação',
		moeda: 'moeda',
		Moeda: 'Moeda',
		armazem: 'armazem',
		Armazém: 'Armazém',
		Remover_Imagem: 'Remover Imagem',
		Adicionar_Imagem: 'Adicionar_Imagem',
		As_dimensões_da_imagem_devem_ser_800px_x_600px: 'As dimensões da imagem devem ser 800px x 600px (obrigatório).',
		Esta_carta_já_foi_registada: 'Esta carta já foi registrada.',
		Registo_alterado_com_sucesso: 'Registro alterado com sucesso',
		Registo_criado_com_sucesso: 'Registro criado com sucesso.',
		Ocorreu_um_erro_ao_alterar_o_registo: 'Ocorreu um erro ao alterar o registro',
		Ocorreu_um_erro_ao_criar_o_registo: 'Ocorreu um erro ao criar o registro.',
		O_campo_Nome_é_obrigatório_no_idioma: 'O campo Nome é obrigatório no idioma',
		O_campo_Moeda_é_obrigatório: 'O campo Moeda é obrigatório.',
		O_campo_Armazém_é_obrigatório: 'O campo Armazém é obrigatório.',
		O_campo_Categoria_é_obrigatório: 'O campo Categoria é obrigatório.',
		Ocorreu_um_erro: 'Ocorreu um erro.',
		Artigo_de_Venda: 'Artigo de Venda',
		Este_menu_já_foi_registado: 'Este menu já foi registrado.',
		Ordem_n: 'Ordem (º)',
		Adicionar: 'Adicionar',
		Não_foram_encontrados_capítulos: 'Não foram encontrados capítulos.',
		O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a:'O campo Ordem deve ser númerico e maior ou igual a 0.',
		O_campo_Nome_é_obrigatório: 'O campo Nome é obrigatório.',
		Medidas: 'Medidas',
		Artigo_de_Venda: 'Artigo de Venda',
		Atualizar: 'Atualizar',
		Não_foram_encontrados_subcapítulos: 'Não foram encontrados subcapítulos',
		Litro: 'Litro',
		Decilitro: 'Decilitro',
		Centilitro: 'Centilitro',
		Mililitro: 'Mililitro',
		Minuto: 'Minuto',
		Não_foram_encontrados_capítulos_para_o_idioma_seleccionado: 'Não foram encontrados capítulos para o idioma seleccionado.',
		O_campo_Quantidade_é_obrigatório: 'O campo Quantidade é obrigatório.',
		O_campo_Medida_é_obrigatório: 'O campo Medida é obrigatório.',
		O_campo_Preço_deve_ser_numérico: 'O campo Preço deve ser numérico.',
		O_campo_Preço_é_obrigatório_e_deve_ser_numérico: 'O campo Preço é obrigatório e deve ser numérico.',
		Não_foram_adicionadas_medidas: 'Não foram adicionadas medidas.',
		O_campo_Preço_é_obrigatório: 'O campo Preço é obrigatório.',
		Zonas: 'Zonas',
		Data_de_Validade: 'Data de Validade',
		Upload: 'Upload',
		Destaque: 'Destaque',
		Pública: 'Pública',
		Privada: 'Privada',
		Resposta1: '1 Resposta',
		Várias_Opções: 'Várias Opções',
		Resposta: 'Resposta',
		A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif: 'A imagem tem ser do tipo jpeg, jpg, png ou gif',
		O_ficheiro_tem_de_ser_um_pdf: 'O ficheiro tem de ser um pdf.',
		Lista_de_Notícias: 'Lista de Notícias',
		Autor: 'Autor',
		Detalhe: 'Detalhe',
		Data_Inicio: 'Data Inicio',
		Data_Fim: 'Data Fim',
		Evento_apagado: 'Evento apagado.',
		Deseja_mesmo_apagar_o_evento: 'Deseja mesmo apagar o evento?',
		Apagar: 'Apagar',
		O_evento_será_apagado_e_não_será_possível_recuperá_lo: 'O evento {name} será apagado e não será possível recuperá-lo.',
		Privado: 'Privado',
		Não_é_possível_visualizar_o_documento: 'Não é possível visualizar o documento.',
		Já_chegou_ao_limite_de_ficheiros: 'Já chegou ao limite de ficheiros.',
		Apenas_são_aceites_PDFs_documentos_Word_ou_imagens: 'Apenas são aceites PDFs, documentos Word ou imagens com formato jpeg, jpg ou png.',
		O_ficheiro_não_pode_ter_mais_de_10mb: 'O ficheiro não pode ter mais de 10mb.',
		O_campo_Assunto_é_obrigatório: 'O campo Assunto é obrigatório.',
		O_campo_Categoria_é_obrigatório: 'O campo Categoria é obrigatório.',
		O_campo_Descrição_é_obrigatório: 'O campo Descrição é obrigatório.',
		Passou_o_limite_de_caracteres_para_o_campo_Descrição: 'Passou o limite de caracteres para o campo Descrição.',
		Participação_registada_com_sucesso: 'Participação registrada com sucesso.',
		Este_directório_já_foi_registado: 'Este directório já foi registrado.',
		Só_é_permitido_um_directório_por_hotel: 'Só é permitido um directório por hotel.',
		Ficheiros: 'Ficheiros',
		Data_de_Início: 'Data de Início',
		Data_de_Fim: 'Data de Fim',
		A_Data_de_Início_não_está_selecionada: 'A Data de Início não está selecionada.',
		A_Data_de_Fim_não_está_selecionada: 'A Data de Fim não está selecionada.',
		Titulo: 'Titulo',

	},
	// Lang BR




	// Lang DE
	de: {
		fromOurTradition: 'From Our Tradition',	
		description: 'Description',
		price: 'Price',
		restaurantFood: 'Val Moreira Restaurant | Food',
		restaurantDrinks: 'Val Moreira Restaurant | Drinks',
		appetizers: 'Appetizers',
		appetizer_one: 'Green asparagus cream soup, crispy traditional smoked sausage and chives',
		appetizer_two: 'Our traditional green broth',
		appetizer_three: 'Fresh cheese salad with peach, smoked ham and almonds',
		appetizer_four: 'Grilled rustic bread with olive oil and garlic, traditional Lamego smoked sausage and quail egg',
		appetizer_five: 'Shrimps in tempura, mango, kiwi chutney, sweet chili and salad sprouts',
		dish_monday: 'Deep-fried meat-filled pastries with lima beans rice',
		dish_tuesday: 'Octopus fillets with broccoli rabe rice',
		dish_wednesday: 'Old-fashioned style duck rice',
		dish_thursday: 'Cod loins roasted with onions and boiled potatoes',
		dish_friday: 'Game meat pie with sautéed spinach',
		dish_saturday: 'Cavado river trouts with smoked ham and boiled potatoes',
		dish_sunday: 'Roast kid with potatoes and sautéed broccoli rabe',
		Cliente: 'Client',
		Orders: 'Room Service',
		account: 'Account',
		Estadia: 'Stay',
		Checkin: 'Check-In Online',
		vSelectNoResults: 'No results found.',
		vSelectNoOptions: 'No options available',
		EstadiasAnteriores: 'Past Stays',
		QuestionarioSatisfacao: 'Questionnaires',
		InstantFeedback: 'Instant Feedback',
		Cartas: 'Crata',
		Capitulo: 'Capitulo',
		Chapters: 'Chapters',
		Subcapitulos: 'Subcapitulo',
		MenuSetup: 'Setup',
		Restauracao: 'Menus',
		RestauranteValMoreiraComida: 'Val Moreira Restaurant | Menu',
		RestauranteValMoreiraBebidas: 'Val Moreira Restaurant | Drinks',
		BarValMoreira: 'Val Moreira Bar',
		PequenoAlmoco: 'Breakfast',
		ChaDas5: '5 O\'Clock Tea',
		MenuNep: 'NEP Menu',
		VinhosAdega: 'Wines / Winery',
		Gins: 'Gins',
		Servicos: 'Services',
		Piscina: 'Pool',
		Lavandaria: 'Loundry',
		Minibar: 'Minibar',
		VinhosAzeites: 'Wines / Olive Oil',
		RoomService: 'Room Service',
		Spa: 'Spa',
		DirectorioAZ: 'Directory A-Z',
		IvaCorrente: 'VAT Included at current rate.',
		LivroReclamacoes: 'This property has a complaint book.',
		PrevencaoAlergias: 'For the prevention of potential allergies, there is a technical sheet describing the ingredients used. No plate, food or drink, including the couvert, can be charged if not requested by the customer or it is rendered inoperable.',
		PrevencaoIncendios: 'Fire Prevention',
		EstadiaActual: 'Your Current Stay',
		ContaDeQuarto: 'Your Current Room Bill',
		pontoDeVenda: 'Sale Point',
		dataHora: 'Date',
		artigoFactura: 'Invoiced article',
		amount: 'Amount',
		billConfirmation: 'Confirmed',
		SuasEstadiasAnteriores: "Your past Stays",
		WakeUp: "Wake Up Service",
		naoPerturbar: "Do Not Disturb Service",
		suporte: "Maintenance",
		Produtos: "Products",
		Welcome_M: "Welcome",
		Welcome_F: "Welcome",
		gerirConteudos: "Conteúdos",
		gerirUtilizadores: "Permissões",
		pesquisarUtilizador: "Search User",
		Administracao: "Management",
		editUserRole: "Edit Permissions",
		insertUserId: "Email, Id or Name",
		Gravar: "Save",
		roleActual: "Permission",
		roleSuccess: "Role changed with success.",
		gerirConteudoMain: "Manage Main Page Content",
		directorio: "Directory",
		main_page: "Homepage",
		edit_hotel: "Select the Hotel to edit: ",
		current_hotel: "Current Hotel",
		select_hotel: "Select Hotel",
		corporate_images: "Corporate Images",
		password: 'Password',
		register: 'Register',
		user: 'User',
		user_email: 'Username or Email',
		invalid_credentials: 'Invalid credentials',
		attention: 'Attention.',
		mandatory_user: 'The user field is mandatory.',
		mandatory_password: 'The password field is mandatory.',
		login_password: 'The fields user and password are mandatory.',
		error_password: 'Invalid password.',
		added_item_to_cart: 'Item successfully added to cart.',
		order_placed: 'Your order was successfully placed.',
		success: 'Success.',
		order_error: 'There was an error while placing your order, please try again.',
		user_not_found: 'No records were found.',
		empty_search_filed: 'The search field can not be empty.',
		en: 'Englisch',
		pt: 'Portugiesisch',
		br: 'Portugiesisch',
		de: 'Deutsche',
		fr: 'Französisch',
		es: 'Spanisch',
		dont_show_popup: "Don't show this message again.",
		empty_feedback: 'There are questions with no answer selected.',
		feedback_comments: 'Comments (optional)',
		feedback_thanks: 'Thank you for your feedback.',
		noFeedback: 'Instant feedback unavailable because there is no stay in progress.',
		submit: "Submit",
		long_comment_feedback: "Your comments exceeded the character limit.",
		corporate_banners: 'Vila Galé Group',
		changeRole: 'Role successfully changed.',
		addRole: 'Role successfully added.',
		removeRole: 'Role SUccessfully removed.',
		instantFeedback: 'Instant Feedback',
		noAvailableFeedback: 'Instant feedback unavailable because there is no stay in progress.',
		legalNotice: 'Legal Notice',
		legalNoticeUrl: 'https://www.vilagale.com/en/privacy-policy',
		privacyPolicy: 'Policy Privacy',
		privacyPolicyUrl: 'https://www.vilagale.com/en/legal-notice',
		complaintsBook: 'Complaints Book',
		complaintsBookUrl: 'https://www.livroreclamacoes.pt/inicio/',
		Noticias: 'News',
		Carta: 'Carta',
		Cartas: 'Cartas',
		noCheckin: 'There are no reservations for Check-In Online.',
		noSurvey: 'There are no questionnaires to answer.',
		questionnaires: 'Questionnaires',
		reservation: 'Reservation',
		answer: 'Answer',
		open: 'Öffnen',
		CartasSide: 'Menüs',
		noOrders: "There are no orders placed",
		emptyCart: "Your Cart Is Empty.",
		returnButton: 'Rückkehr',
		description: 'Description',
		noMenus: 'Es sind keine Menüs verfügbar.',
		noItems: 'There are no items available.',
		noChapter: 'Menü ist nicht verfügbar.',
		noDirectory: 'Directory A-Z not available.',
		noDirectoryLang: 'Directory A-Z not available for this language.',
		noItemsAvailable: 'Es sind keine Artikel verfügbar.',
		quantity: 'Menge',
		noItemsInCart: 'Ihr Warenkorb ist leer.',
		seeMenus: 'Menüs anzeigen',
		save_item_rejected: 'Speichern',
		finishOrder: 'Bestätigen',
		remove: 'Entfernen',
		notes: 'Beobachtungen',
		noStay: 'Der Zimmerservice ist nicht verfügbar, da kein laufender Aufenthalt stattfindet.',
		placedOrders: 'Aufgegebene Bestellungen',
		cancels: 'Stornieren',
		yourCart: 'Ihr Warenkorb.',
		noPlacedOrders: 'Es liegen keine Bestellungen vor.',
		revocerPassword: 'Passwort vergessen?',
		item: 'Artikel',
		local: 'Lokal',
		date: 'Datum',
		account_quantity: 'Stk.',
		value: 'Wert',
		reject: 'Ablehnen',
		Noticia: 'Nachricht',
		Questionario: 'Quiz',
		Voltar: 'Zurückkehren',
		Comentario: 'Kommentar',
		Comentar: 'Kommentar',
		Ver_mais: 'Mehr anzeigen',
		Saber_mais: 'Mehr wissen',
		nao_foram_encontradas_noticias: 'Es wurden keine Neuigkeiten gefunden.',
		Todas: 'Alle',
		Comidas: 'Lebensmittel',
		Bebidas: 'Getränke',
		Outras: 'Sonstiges',
		Filtro: 'Filter',
		Pesquisa: 'Suchen',
		Perfil: 'Profil',
		Clube: 'Verein',
		send_account_info: 'Schicken',
		reject_items_question: 'Bitte sagen Sie uns, warum.',
		approved : "Genehmigt",
		to_send : "Pedaltritt",
		rejected_at : "Abgelehnt bei",
		rejected : "Abgelehnt",
		status : "Status",
		payments: "Zahlung",
		pago    : "Bezahlt",
		client_accounts: 'Kundenkonten',
		client_account: 'Kundenkonto',
		end_payment : 'Zahlungsabwicklung',
		account_no_items : 'Für dieses Konto sind keine Artikel vorhanden',
		Informations: 'Informationen',
		Nao_existem_conteudos_hotel_selecionado: 'Für das ausgewählte Hotel liegen keine Inhalte vor.',
		Selecione_hotel_ver_conteúdo: 'Wählen Sie ein Hotel aus, um dessen Inhalt anzuzeigen.',
		success_rsv_checkout : 'Check-out erfolgreich abgeschlossen.',
		account_no_items : 'Es liegen keine eingetragenen Verbrauchswerte vor.',
		success_rsv_checkout : 'Ihr Check-out wurde erfolgreich abgeschlossen!<br>Hinterlassen Sie die Schlüsselkarte(n) Ihres/Ihrer Zimmer(s) an der Rezeption in der dafür vorgesehenen Box.<br><br>Wir danken Ihnen für Ihre Präferenz und freuen uns, Sie bald wiederzusehen!',
		checkout_text_w_items: 'Es gibt offene Werte in Ihrer Reservierung. Bitte bestätigen Sie, dass alles korrekt ist',
		checkout_text_no_items: 'Schnell und einfach auschecken. Klicken Sie auf die Schaltfläche unten:',
		checkout_warning: 'Bitte gehen Sie zum Auschecken zur Rezeption.',
		checkout_warning_w_rejected: 'Bitte gehen Sie zur Überprüfung Ihrer Rechnung zur Rezeption.',
		client_account_sentence: 'Bitte bestätigen Sie Ihren Konsum während Ihres Aufenthaltes in der Liste unten',
		confirmed_account_msg: 'Bestätigung erfolgreich registriert.',
		discount: 'Rabatt',
		checkout_done: 'Option nur verfügbar, wenn ein Aufenthalt im Gange ist.',
		appointments: 'Buchungen',
		animation: 'Animation',
		laundry: 'Wäscherei',
		associate_rsv: 'Link zu einer bestehenden Reservierung',
		rsv_number: 'Reservierungsnummer',
		your_rsv: 'Ihre Reservierung',
		your_next_rsv: 'Ihre nächste Reservierung',
		room_number: 'Zimmer Nr.',
		rsv_succed: 'Reservierung erfolgreich erstellt.',
		str_hour_schedule: 'Von {start_time} bis {end_time}',
		bookings_no_items: 'Es liegen keine eingetragenen Reservierungen vor.',
		my_appointments: 'Meine Reservierungen',
		people_n: 'Personenanzahl',
		service: 'Service',
		service_type: 'Diensttyp',
		horario: 'Std',
		horarios: 'Std',
		space: 'Raum',
		space_type: 'Raumtyp',
		availability: 'Verfügbarkeit',
		type_of: 'Art der',
		dish: 'Gericht',
		newa: 'Neu',
		newo: 'Neu',
		cancelled: 'Abgesagt',
		aviso: 'Alarm',
		yes: 'Ja',
		no: 'Nein',
		my_bookings_sentence: 'Sehen Sie Ihre Reservierungen in der Liste unten.',
		Entretenimento: 'Unterhaltung',
		Noticiass: 'Nachricht',
		Eventos: 'Veranstaltungen',
		Eventoss: 'Veranstaltungen',
		payment_msg: "Die Bezahlung der jetzt oder zu einem späteren Zeitpunkt konsumierten Waren und Dienstleistungen können Sie an der Rezeption des Hotels vornehmen.",
		consult: 'Konsultieren',
		no_spaces: 'Eine Terminvereinbarung ist nicht möglich. Bitte wenden Sie sich hierfür an die Rezeption.',
		no_shedules: 'Es liegen keine Fahrpläne vor. Bitte wenden Sie sich an die Rezeption.',
		booking_removed: 'Reservierung erfolgreich entfernt.',
		Configuration: 'Konfiguration',
		error: 'Fehler',
		VilaGaleSTAR: 'Vila Galé STAR',
		Inovar_Motivar: 'Innovativ motivieren',
		Configuration: 'Konfiguration',
		check_cartas_login: 'Möchten Sie unsere Menüs ansehen?<br>Klicken Sie',
		check_entertainment_login: 'Möchten Sie sich unsere Unterhaltungsprogramme ansehen?<br>Klicken Sie hier',
		here: 'hier',
		Parcerias: 'Partnerschaften',
		Parceriass: 'Partnerschaften',
		Categorias: 'Kategorien',
		Todos: 'Alle',
		payment_success : 'Zahlung erfolgreich',
		hotel: 'Hotel',
		Configuration: 'Einstellungen',
		payment_success : 'Zahlung erfolgreich durchgeführt',
		payment_pending : 'Die Zahlung steht aus. Bitte rufen Sie die Anwendung auf und autorisieren Sie die Zahlung.',
		no_reservations_available: 'Es sind keine Reservierungen verfügbar.',
		recover_1: 'Ihre Zugangsdaten wurden an die folgende E-Mail-Adresse gesendet:',
		recover_2: '. Wenn Sie unsere E-Mail nicht erhalten haben (überprüfen Sie bitte alle Ordner, einschließlich des Spam-Ordners), klicken Sie',
		recover_3: ', und wir senden Ihnen die E-Mail noch einmal.',
		just_a_second: 'Augenblick...',
		recover_aqui: 'Hier',
		contact: 'Ein Fehler ist aufgetreten. Bitte kontaktieren Sie uns.',
		recover_title: 'Passwort-Wiederherstellung',
		erro_date: 'Fehler beim ausgewählten Datum.',
		new_password: 'Neues Passwort',
		new_password_desc: 'Bevor Sie zu My Vila Galé gelangen, müssen Sie Ihr Passwort ändern.',
		password_changed: 'Das neue Passwort wurde erfolgreich registriert.',
		submeter: 'Absenden',
		missing_pass: 'Das Feld „Passwort“ ist ein Pflichtfeld.',
		missing_conf_pass: 'Das Feld „Passwort bestätigen“ ist ein Pflichtfeld.',
		pass_not_match: 'Die Felder „Passwort“ und „Passwort bestätigen“ stimmen nicht überein.',
		tipo_de_marcacao: 'Markierungstyp',
		tipo_de_espaco: 'Art des Raums',
		data_do_registo: 'Registrierungsdatum',
		mesas: 'Tafelberge',
		n_quarto: 'Raum Nummer.',
		grupo: 'Gruppe',
		n_presenças: 'Anzahl der Teilnehmer',
		registado_por: 'Registriert durch',
		observacoes: 'Kommentare',
		nome: 'Name',
		n_grupo: 'Gruppennr',
		regime: 'Regime',
		n_presencas: 'Anzahl der Teilnehmer',
		ver: 'Um zu sehen',
		n_presencas_registado: 'Anzahl der erfolgreich registrierten Teilnahmen.',
		erro_numero_distribuicao_reserva: 'Fehler - Reservierungsverteilungsnummer',
		erro_numero_pessoas: 'Fehler - Anzahl der Personen',
		erro_guardar_n_presencas: 'Fehler beim Speichern der Anwesenheitsnummer.',
		Pesquisar: 'Suchen',
		obrigatorio_inserir_n_reserva_n_quarto: 'Die Eingabe der Reservierungsnummer bzw. Zimmernummer ist zwingend erforderlich.',
		sair: 'Ausgehen',
		Limpar: 'Reinigen',
		Grupos: 'Gruppen',
		Passante: 'Passant',
		Reserva: 'Reservierung',
		Pessoas: 'Leute',
		Houve_um_colega_que_se_destacou: 'Hat sich ein Kollege hervorgetan?',
		Nomeia_o_para_o_Vila_Gale_Star: 'Nominiere ihn für den Vila Galé Star!',
		Todos_os_meses_e_eleito_um_vencedor: 'Jeden Monat wird ein Gewinner gewählt!',
		Quem_sabe_se_tu_nao_seras_o_proximo: 'Wer weiß, vielleicht bist du der Nächste!',
		Ano: 'Jahr',
		Trimestre: 'Quartal',
		Mes: 'Monat',
		Portugal: 'Portugal',
		E_a_cada_3_meses: 'Und alle 3 Monate,',
		havera_uma_decisao_com_premio: 'wird es eine Entscheidung mit einem Preis geben!',
		Quem_sabe_se_es_o_proximo: 'Wer weiß, vielleicht bist du der nächste!',
		Faz_nos_Brilhar: 'Lass uns strahlen!',
		Regulamento: 'Reglement',
		Nomear: 'Nominieren',
		Finalidade: 'Zweck',
		O_programa_visa_evidenciar_o_merito_do_desempenho_dos: 'Das Programm zielt darauf ab, die Verdienste der Mitarbeiterleistung hervorzuheben, in einem Entscheidungsmodell, das von den anderen Mitgliedern der Einheit oder Abteilung partizipativ gestaltet wird.',
		Metodo: 'Methode',
		O_programa_divide_se_em_4_fases: 'Das Programm ist in 4 Phasen unterteilt:',
		Mensal: 'Monatlich',
		votacao: 'Abstimmung',
		a_votacao_doa_vg_star_mensal_e_feita_atraves_das: 'Die Abstimmung des VG STAR Monatlich erfolgt über die Nominierungen der Kollegen auf den Formularen des ISL-Plakats, My Vila Galé und ERP, der Kunden über interne Zufriedenheitsfragebögen und andere digitale Plattformen sowie in Leitungssitzungen.',
		eleicao: 'Wahl',
		a_eleicao_do_vg_star_mensal_e_feita_atraves_da: 'Die Wahl des VG STAR Monatlich erfolgt durch die Gewichtung der Nominierungen der Kollegen (40%), die Erwähnungen der Kunden (40%) und die Leitungssitzung (20%). Der Gewinner/die Gewinnerin sollte am letzten Tag eines jeden Monats bekannt gegeben werden. Im Dezember wird es keine Wahl geben.',
		premios: 'Preise',
		ao_vencedor_do_vg_star_mensal_e_atribuido: 'Dem Gewinner/der Gewinnerin des VG STAR Monatlich wird:',
		o_premio_de_5000_em_vale_valor_ivla_gale_carregados: 'Der Preis von 50,00€ in Vale Valor Vila Galé, geladen auf das Profil im ERP;',
		sera_divulgadoa_oa_vencedora_atraves: 'Der Gewinner/die Gewinnerin wird über das ISL-Plakat bekannt gegeben.',
		criterios_de_nao_eleicao: 'Kriterien der NICHT-Wahl',
		falta_injustificada_no_mes_da_nomeacao: 'Unentschuldigtes Fehlen im Monat der Nominierung;',
		advertencia_por_escrito: 'Schriftliche Verwarnung;',
		reclamacoes_com_o_seu_nome: 'Beschwerden mit seinem Namen;',
		ter_sido_eleito_a_no_presente_trimestre: 'Im laufenden Quartal gewählt worden sein.',
		trimestral: 'Vierteljährlich',
		oa_vg_star_trimestral_sera_uma_dosas_colegas: 'Der VG STAR Vierteljährlich wird einer der Kollegen aus derselben Einheit sein, der in den letzten 3 Monaten VG STAR Monatlich gewonnen hat.',
		a_eleicao_do_vg_star_trimestral_e_feita_atraves: 'Die Wahl des VG STAR Vierteljährlich erfolgt durch Leitungssitzungen unter Berücksichtigung der 3 Gewinner der letzten Monate. Der Gewinner/die Gewinnerin wird bis zum 15. des Monats nach dem Ende des Quartals bekannt gegeben, außer im Dezember. (15. April, 15. Juli, 15. Oktober, 5. Dezember).',
		ao_vencedora_do_vg_star_trimestral_sao: 'Dem Gewinner/der Gewinnerin des VG STAR Vierteljährlich werden folgende Preise verliehen:',
		em_vale_valor_carregados_no_profile_em_erp_50: '50,00€ in Vale Valor, geladen auf das Profil im ERP (zusätzlich zu den 50,00€, die für den VG Star Monatlich geladen wurden);',
		badge_com_estrela_que_devera_ser_utilizado_durante: 'Abzeichen mit Stern, das das ganze Jahr getragen werden muss;',
		sera_divulgado_a_o_a_vencedor_a_para_os_clientes: 'Der Gewinner/die Gewinnerin wird den Kunden über den Fernseher an der Rezeption und das My Vila Galé-Portal bekannt gegeben.',
		falta_injustificada_no_trimestre: 'Unentschuldigtes Fehlen im Quartal;',
		advertencia_por_escrito: 'Schriftliche Verwarnung;',
		atrasos_injustificados_no_trimestre: 'Unentschuldigtes Zuspätkommen im Quartal;',
		altercacoes: 'Streitigkeiten;',
		ter_sido_nomeado_vg_star_trimestre_no_presente_ano: 'Im laufenden Jahr zum VG STAR des Quartals nominiert worden sein.',
		a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de: 'Die Wahl des VG SUPERSTAR Hotels erfolgt durch eine Führungskräftesitzung bis zum 5. Dezember jedes Jahres. Der/die Gewählte muss einer der VG STAR der vier Quartale sein..',
		aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios: 'Dem Gewinner/der Gewinnerin des VG SUPERSTAR Hotel werden folgende Preise verliehen',
		em_vale_valor_carregados_no_profile_em_erp_100: '100,00€ in Vale Valor, geladen auf das Profil im ERP',
		um_cabaz_de_Natal_e_osas_vencedoresas_serão_anunciados: 'ein Weihnachtskorb und die Gewinner werden auf der Weihnachtsfeier bekannt gegeben',
		sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL: 'Der Gewinner/die Gewinnerin wird über das ISL-Plakat und den Kunden über den Fernseher an der Rezeption und das My Vila Galé-Portal bekannt gegeben',
		todas_os_criterios_referidos_no_vg_star: 'Alle im VG STAR genannten Kriterien;',
		nao_ter_sido_vencedora_do_vg_star: 'Nicht VG STAR Gewinner gewesen sein.',
		Nacional: 'National',
		oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos: 'Der VG SUPERSTAR National wird durch die Analyse der Gewinner des VG SUPERSTAR jedes Hotels ermittelt',
		a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri: 'Die Wahl des VG SUPERSTAR National erfolgt durch eine Jury, bestehend aus der Betriebsleitung, der Geschäftsführung und der Finanzleitung.',
		ao_vencedor_do_vg_superstar_nacional_sao_atribuidos: 'Dem Gewinner/der Gewinnerin des VG SUPERSTAR National werden folgende Preise verliehen',
		em_vale_valor_carregados_no_profile_em_erp_200: '200,00€ in Vale Valor, geladen auf das Profil im ERP;',
		oa_vencedora_sera_convidadoa_a_estar_presente: 'Der Gewinner/die Gewinnerin wird eingeladen, an der Jahrestagung der Gruppe teilzunehmen und wird in E-feel Staff, My Vila Galé und auf Whatsapp erwähnt;',
		sera_divulgado_o_vencedor_para_os_clientes: 'Der Gewinner/die Gewinnerin wird den Kunden über den Fernseher an der Rezeption und das My Vila Galé-Portal bekannt gegeben.',
		todas_os_criterios_referidos_no_vg_star: 'Alle im VG STAR genannten Kriterien;',
		nao_ter_sido_vencedor_a_do_vg_star: 'Nicht VG STAR Gewinner gewesen sein.',
		Nenhum_colaborador_encontrado: 'Kein Mitarbeiter gefunden',
		O_campo_Colaborador_é_obrigatório: 'Das Feld Mitarbeiter ist obligatorisch',
		O_campo_Motivo_é_obrigatório: 'Das Feld Grund ist obligatorisch',
		Passou_o_limite_de_caracteres_para_o_campo_Motivo: 'Sie haben das Zeichenlimit für das Feld Grund überschritten',
		Nomeação_registada_com_sucesso: 'Danke für Ihre Nominierung.',
		Este_mês_já_fez_uma_nomeação: 'Diesen Monat haben Sie bereits eine Nominierung vorgenommen',
		SelecionarIdioma: 'Sprache auswählen',
		Idioma: 'Sprache',
		Nova: 'Neu',
		Link: 'Link',
		Corporativo: 'Firmenkunde',
		PortuguêsPT: 'Portugiesisch PT',
		PortuguêsBR: 'Portugiesisch BR',
		O_tamanho_máximo_permitido_para_a_imagemé_de_200kb: 'Die maximal zulässige Bildgröße beträgt 200 kb',
		As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório: 'Die Bildabmessungen müssen 500px x 500px betragen (obligatorisch)',
		Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif: 'Bilder müssen vom Typ \'.jpg\', \'.jpeg\', \'.png\' oder \'.gif\' sein',
		O_campo_Idioma_é_obrigatório: 'Das Feld Sprache ist obligatorisch',
		O_campo_Hotel_é_obrigatório: 'Das Feld Hotel ist obligatorisch',
		Registo_criado_com_sucesso: 'Eintrag erfolgreich erstellt',
		Ocorreu_um_erro_ao_criar_o_registo: 'Beim Erstellen des Eintrags ist ein Fehler aufgetreten',
		Registo_eliminado_com_sucesso: 'Eintrag erfolgreich gelöscht',
		Ocorreu_um_erro_ao_eliminar_o_registo: 'Beim Löschen des Eintrags ist ein Fehler aufgetreten',
		INOVAR: "INNOVIEREN",
		MOTIVAR: "MOTIVIEREN",
		Inovar_Motivar: "Innovieren Motivieren",
		Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar: "Nehmen Sie am Programm Innovieren Motivieren teil und qualifizieren Sie sich, um 75€ zu gewinnen.",
		Vamos_contribuir_para_a_mudança_do_nosso_grupo: "Lasst uns zur Veränderung unserer Gruppe beitragen!",
		Inova_e_Ganha: "Innoviere und Gewinne!",
		Participar: "Teilnehmen",
		O_programa_visa_incentivar_a_participação_de_todos_no: "Das Programm zielt darauf ab, die Teilnahme aller an der Entwicklung des Unternehmens zu fördern, ihre Ideen und Vorschläge zu würdigen und eine stärkere Einbindung und Verbindung zwischen allen Mitarbeitern und Vila Galé zu schaffen.",
		As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada: "Ideen oder Vorschläge, die bis zum Ende jedes Quartals eingereicht werden, werden von einem VG LAB bewertet.",
		Para_participar_basta_preencher_o_formulário_em_papel: "Um teilzunehmen, füllen Sie einfach das Formular auf Papier oder online aus (ERP/My Vila Galé).",
		As_ideias_apresentadas_serão_classificadas_em: "Die eingereichten Ideen werden in 3 Kriterien eingeteilt:",
		Relevantes_e_finalizadas_para_implementação_premiadas: "Relevant und zur Umsetzung abgeschlossen - prämiert;",
		Desenvolvimento_o_a_colaborador_a_será_convidado: "Entwicklung - der/die Mitarbeiter/in wird eingeladen, seine/ihre Idee so zu verbessern, dass sie umsetzbar wird;",
		Não_relevantes: "Nicht relevant.",
		A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor: "Die prämierten Ideen erhalten einen Preis im Wert von 75€ auf einer Sonae-Karte oder 100€ in einem VG-Incentive-Gutschein.",
		Fatores_eliminatórios_apenas_a_sugestão_ou_ideia: "Ausschlusskriterien (nur die geeignete Vorschläge oder Ideen können nominiert werden):",
		Inovação_e_originalidade: "Innovation und Originalität",
		Valor_acrescentado_para_a_empresa: "Mehrwert für das Unternehmen",
		Necessidade_de_implementação: "Umsetzungsbedarf",
		Exequibilidade_operacional: "Operative Durchführbarkeit",
		Método_de_implementação: "Implementierungsmethode",
		Custos_de_implementação: "Implementierungskosten",
		As_ideias_ou_sugestões_relevantes_não_serão_premiadas: "Relevante Ideen oder Vorschläge werden in der ersten Phase nicht prämiert, können aber nach Entwicklung durch den/die Mitarbeiter/in prämiert werden.",
		Em_caso_de_ideias_similares_apenas_uma_será_premiada: "Im Falle ähnlicher Ideen wird nur eine prämiert. In der folgenden Auswahlreihenfolge:",
		Mais_critérios_eliminatórios_adequados: "Weitere geeignete Ausschlusskriterien;",
		Custos_de_implementação_calculados: "Berechnete Implementierungskosten;",
		Data_de_submissão: "Einreichungsdatum.",
		Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir: "Das VG LAB Bewertungsteam behält sich das Recht vor, keine Preise zu vergeben, wenn keine Idee präsentiert wird oder wenn die präsentierten Ideen nicht die Bedingungen für die Preisvergabe erfüllen.",
		Colaborador: "Mitarbeiter",
		Motivo: "Grund",
		Assunto: "Betreff",
		Categoria: "Kategorie",
		Descrição: "Beschreibung",
		Ficheiro: "Datei",
		Imagem: "Bild",
		Tipo: "Typ",
		Não_foram_encontradas_cartas_para_o_hotel_selecionado: "Für das ausgewählte Hotel wurden keine Briefe gefunden.",
		Menu: "Menü",
		Directório: "Verzeichnis",
		Marcação: "Markierung",
		Capitulo: "Kapitel",
		Erro_nos_subcapitulos: "Fehler in den Unterkapiteln.",
		Carta_copiada_com_sucesso: "Brief erfolgreich kopiert.",
		Erro_a_gravar: "Fehler beim Speichern",
		O_campo_Hotel_é_obrigatório: "Das Feld Hotel ist erforderlich.",
		Deseja_mesmo_apagar: "Möchten Sie wirklich löschen?",
		Pretende_eliminar: "Möchten Sie löschen",
		Erro_a_obter_hoteis: "Fehler beim Abrufen der Hotels",
		Visivel: "Sichtbar",
		Nome_Impressão: "Druckname",
		Informação: "Information",
		moeda: "Währung",
		Moeda: "Währung",
		armazem: "Lager",
		Armazém: "Lager",
		Remover_Imagem: "Bild entfernen",
		Adicionar_Imagem: "Bild hinzufügen",
		As_dimensões_da_imagem_devem_ser_800px_x_600px: "Die Bildabmessungen müssen 800px x 600px betragen (obligatorisch).",
		Esta_carta_já_foi_registada: "Dieser Brief wurde bereits registriert.",
		Registo_alterado_com_sucesso: "Eintrag erfolgreich geändert",
		Registo_criado_com_sucesso: "Eintrag erfolgreich erstellt.",
		Ocorreu_um_erro_ao_alterar_o_registo: "Beim Ändern des Eintrags ist ein Fehler aufgetreten",
		Ocorreu_um_erro_ao_criar_o_registo: "Beim Erstellen des Eintrags ist ein Fehler aufgetreten.",
		O_campo_Nome_é_obrigatório_no_idioma: "Das Feld Name ist in der Sprache erforderlich",
		O_campo_Moeda_é_obrigatório: "Das Feld Währung ist erforderlich.",
		O_campo_Armazém_é_obrigatório: "Das Feld Lager ist erforderlich.",
		O_campo_Categoria_é_obrigatório: "Das Feld Kategorie ist erforderlich.",
		Ocorreu_um_erro: "Ein Fehler ist aufgetreten.",
		Artigo_de_Venda: "Verkaufsartikel",
		Este_menu_já_foi_registado: "Dieses Menü wurde bereits registriert.",
		Ordem_n: "Bestellung (º)",
		Adicionar: "Hinzufügen",
		Não_foram_encontrados_capítulos: "Es wurden keine Kapitel gefunden.",
		O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a: "Das Feld Bestellung muss numerisch und größer oder gleich 0 sein.",
		O_campo_Nome_é_obrigatório: "Das Feld Name ist erforderlich.",
		Medidas: "Maße",
		Artigo_de_Venda: "Verkaufsartikel",
		Atualizar: "Aktualisieren",
		Não_foram_encontrados_subcapítulos: "Es wurden keine Unterkapitel gefunden",
		Litro: "Liter",
		Decilitro: "Deziliter",
		Centilitro: "Zentiliter",
		Mililitro: "Milliliter",
		Minuto: "Minute",
		Não_foram_encontrados_capítulos_para_o_idioma_seleccionado: "Es wurden keine Kapitel für die ausgewählte Sprache gefunden.",
		O_campo_Quantidade_é_obrigatório: "Das Feld Menge ist erforderlich.",
		O_campo_Medida_é_obrigatório: "Das Feld Maß ist erforderlich.",
		O_campo_Preço_deve_ser_numérico: "Das Feld Preis muss numerisch sein.",
		O_campo_Preço_é_obrigatório_e_deve_ser_numérico: "Das Feld Preis ist erforderlich und muss numerisch sein.",
		Não_foram_adicionadas_medidas: "Es wurden keine Maße hinzugefügt.",
		O_campo_Preço_é_obrigatório: "Das Feld Preis ist erforderlich.",
		Zonas: "Zonen",
		Data_de_Validade: "Ablaufdatum",
		Upload: "Hochladen",
		Destaque: "Hervorheben",
		Pública: "Öffentlich",
		Privada: "Privat",
		Resposta1: "1 Antwort",
		Várias_Opções: "Mehrere Optionen",
		Resposta: "Antwort",
		A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif: "Das Bild muss vom Typ jpeg, jpg, png oder gif sein",
		O_ficheiro_tem_de_ser_um_pdf: "Die Datei muss ein PDF sein.",
		Lista_de_Notícias: "Nachrichtenliste",
		Autor: "Autor",
		Detalhe: "Detail",
		Data_Inicio: "Startdatum",
		Data_Fim: "Enddatum",
		Evento_apagado: "Ereignis gelöscht.",
		Deseja_mesmo_apagar_o_evento: "Möchten Sie das Ereignis wirklich löschen?",
		Apagar: "Löschen",
		O_evento_será_apagado_e_não_será_possível_recuperá_lo: "Das Ereignis {name} wird gelöscht und kann nicht wiederhergestellt werden.",
		Privado: "Privat",
		Não_é_possível_visualizar_o_documento: "Das Dokument kann nicht angezeigt werden.",
		Já_chegou_ao_limite_de_ficheiros: "Sie haben das Limit der Dateien erreicht.",
		Apenas_são_aceites_PDFs_documentos_Word_ou_imagens: "Es werden nur PDFs, Word-Dokumente oder Bilder im Format jpeg, jpg oder png akzeptiert.",
		O_ficheiro_não_pode_ter_mais_de_10mb: "Die Datei darf nicht größer als 10mb sein.",
		O_campo_Assunto_é_obrigatório: "Das Feld Betreff ist erforderlich.",
		O_campo_Categoria_é_obrigatório: "Das Feld Kategorie ist erforderlich.",
		O_campo_Descrição_é_obrigatório: "Das Feld Beschreibung ist erforderlich.",
		Passou_o_limite_de_caracteres_para_o_campo_Descrição: "Sie haben das Zeichenlimit für das Feld Beschreibung überschritten.",
		Participação_registada_com_sucesso: "Teilnahme erfolgreich registriert.",
		Este_directório_já_foi_registado: "Dieses Verzeichnis wurde bereits registriert.",
		Só_é_permitido_um_directório_por_hotel: "Es ist nur ein Verzeichnis pro Hotel erlaubt.",
		Ficheiros: "Dateien",
		Data_de_Início: "Startdatum",
		Data_de_Fim: "Enddatum",
		A_Data_de_Início_não_está_selecionada: "Das Startdatum ist nicht ausgewählt.",
		A_Data_de_Fim_não_está_selecionada: "Das Enddatum ist nicht ausgewählt.",
		Titulo: "Titel",

	},
	// Lang DE




	// Lang ES
	es: {
		fromOurTradition: 'Desde Nuestra Tradición',
		description: 'Descripción',
		price: 'Precio',
		restaurantFood: 'Restaurante Val Moreira | Comida',
		restaurantDrinks: 'Restaurante Val Moreira | Bebidas',
		appetizers: 'Entradas',
		appetizer_one: 'Crema de espárragos verdes, chorizo ahumado tradicional crujiente y cebollino',
		appetizer_two: 'Nuestro tradicional caldo verde',
		appetizer_three: 'Ensalada de queso fresco con melocotón, jamón ahumado y almendras',
		appetizer_four: 'Pan tostado a la parrilla con aceite de oliva y ajo, chorizo ahumado tradicional de Lamego y huevo de codorniz',
		appetizer_five: 'Langostinos en tempura, chutney de mango y kiwi, chile dulce y brotes de ensalada',
		dish_monday: 'Pasteles rellenos de carne fritos con arroz de judías lima',
		dish_tuesday: 'Filetes de pulpo con arroz de grelos',
		dish_wednesday: 'Arroz de pato a la antigua',
		dish_thursday: 'Lomos de bacalao asado con cebollas y patatas cocidas',
		dish_friday: 'Pastel de carne de caza con espinacas salteadas',
		dish_saturday: 'Truchas del río Cavado con jamón ahumado y patatas cocidas',
		dish_sunday: 'Cabrito asado con patatas y grelos salteados',
		Cliente: 'Cliente',
		Orders: 'Pedidos',
		account: 'Cuenta',
		Estadia: 'Estadía',
		Checkin: 'Registro en línea',
		vSelectNoResults: 'No se encontraron resultados.',
		vSelectNoOptions: 'No hay opciones disponibles',
		EstadiasAnteriores: 'Estadías Anteriores',
		QuestionarioSatisfacao: 'Cuestionarios',
		InstantFeedback: 'Retroalimentación Instantánea',
		Cartas: 'Cartas',
		Capitulo: 'Capítulo',
		Chapters: 'Capítulos',
		Subcapitulos: 'Subcapítulos',
		MenuSetup: 'Configuración',
		Restauracao: 'Menús',
		RestauranteValMoreiraComida: 'Restaurante Val Moreira | Menú',
		RestauranteValMoreiraBebidas: 'Restaurante Val Moreira | Bebidas',
		BarValMoreira: 'Bar Val Moreira',
		PequenoAlmoco: 'Desayuno',
		ChaDas5: 'Té de las 5',
		MenuNep: 'Menú NEP',
		VinhosAdega: 'Vinos / Bodega',
		Gins: 'Ginebras',
		Servicos: 'Servicios',
		Piscina: 'Piscina',
		Lavandaria: 'Lavandería',
		Minibar: 'Minibar',
		VinhosAzeites: 'Vinos / Aceite de Oliva',
		RoomService: 'Servicio de Habitaciones',
		Spa: 'Spa',
		DirectorioAZ: 'Directorio A-Z',
		IvaCorrente: 'IVA incluido al tipo actual.',
		LivroReclamacoes: 'Este establecimiento dispone de libro de reclamaciones.',
		PrevencaoAlergias: 'Para la prevención de posibles alergias, existe una ficha técnica que describe los ingredientes utilizados. Ningún plato, comida o bebida, incluido el couvert, se puede cobrar si no es solicitado por el cliente o si se vuelve inoperable.',
		PrevencaoIncendios: 'Prevención de Incendios',
		EstadiaActual: 'Su Estadía Actual',
		ContaDeQuarto: 'Su Cuenta Actual de Habitación',
		pontoDeVenda: 'Punto de Venta',
		dataHora: 'Fecha',
		artigoFactura: 'Artículo Facturado',
		amount: 'Cantidad',
		billConfirmation: 'Confirmado',
		SuasEstadiasAnteriores: 'Sus Estadías Anteriores',
		WakeUp: 'Servicio de Despertador',
		naoPerturbar: 'Servicio de No Molestar',
		suporte: 'Mantenimiento',
		Produtos: 'Productos',
		Welcome_M: 'Bienvenido',
		Welcome_F: 'Bienvenida',
		gerirConteudos: 'Contenidos',
		gerirUtilizadores: 'Permisos',
		pesquisarUtilizador: 'Buscar Usuario',
		Administracao: 'Administración',
		editUserRole: 'Editar Permisos',
		insertUserId: 'Correo Electrónico, ID o Nombre',
		Gravar: 'Guardar',
		roleActual: 'Permiso',
		roleSuccess: 'Permiso cambiado con éxito.',
		gerirConteudoMain: 'Gestionar Contenido de la Página Principal',
		directorio: 'Directorio',
		main_page: 'Página de Inicio',
		edit_hotel: 'Seleccione el hotel a editar: ',
		current_hotel: 'Hotel Actual',
		select_hotel: 'Seleccionar Hotel',
		corporate_images: 'Imágenes Corporativas',
		password: 'Contraseña',
		register: 'Registrarse',
		user: 'Usuario',
		user_email: 'Usuario o Correo Electrónico',
		invalid_credentials: 'Credenciales inválidas',
		attention: 'Atención.',
		mandatory_user: 'El campo de usuario es obligatorio.',
		mandatory_password: 'El campo de contraseña es obligatorio.',
		login_password: 'Los campos de usuario y contraseña son obligatorios.',
		error_password: 'Contraseña inválida.',
		added_item_to_cart: 'Artículo añadido al carrito exitosamente.',
		order_placed: 'Su pedido se realizó con éxito.',
		success: 'Éxito.',
		order_error: 'Hubo un error al realizar su pedido, por favor intente nuevamente.',
		user_not_found: 'No se encontraron registros.',
		empty_search_filed: 'El campo de búsqueda no puede estar vacío.',
		en: 'Inglés',
		pt: 'Portugués',
		br: 'Portugués',
		de: 'Alemán',
		fr: 'Francés',
		es: 'Español',
		dont_show_popup: 'No mostrar este mensaje nuevamente.',
		empty_feedback: 'Hay preguntas sin respuesta seleccionada.',
		feedback_comments: 'Comentarios (opcional)',
		feedback_thanks: 'Gracias por sus comentarios.',
		noFeedback: 'La retroalimentación instantánea no está disponible porque no hay una estadía en curso.',
		submit: 'Enviar',
		long_comment_feedback: 'Sus comentarios excedieron el límite de caracteres.',
		corporate_banners: 'Grupo Vila Galé',
		changeRole: 'Rol cambiado con éxito.',
		addRole: 'Rol añadido con éxito.',
		removeRole: 'Rol eliminado con éxito.',
		instantFeedback: 'Retroalimentación Instantánea',
		noAvailableFeedback: 'La retroalimentación instantánea no está disponible porque no hay una estadía en curso.',
		legalNotice: 'Aviso Legal',
		legalNoticeUrl: 'https://www.vilagale.com/es/politica-de-privacidad',
		privacyPolicy: 'Política de Privacidad',
		privacyPolicyUrl: 'https://www.vilagale.com/es/aviso-legal',
		complaintsBook: 'Libro de Reclamaciones',
		complaintsBookUrl: 'https://www.livroreclamacoes.pt/inicio/',
		Noticias: 'Noticias',
		Carta: 'Carta',
		Cartas: 'Cartas',
		noCheckin: 'No hay reservaciones para el Check-In en línea.',
		noSurvey: 'No hay cuestionarios para responder.',
		questionnaires: 'Cuestionarios',
		reservation: 'Reserva',
		answer: 'Responder',
		open: 'Abrir',
		CartasSide: 'Menús',
		noOrders: 'No hay pedidos realizados',
		emptyCart: 'Su Carrito Está Vacío.',
		returnButton: 'Volver',
		description: 'Descripción',
		noMenus: 'No hay menús disponibles.',
		noItems: 'No hay artículos disponibles.',
		noChapter: 'El menú no está disponible.',
		noDirectory: 'Directorio A-Z no disponible.',
		noDirectoryLang: 'Directorio A-Z no disponible para este idioma.',
		noItemsAvailable: 'No hay artículos disponibles.',
		quantity: 'Cantidad',
		noItemsInCart: 'No hay artículos en su carrito.',
		seeMenus: 'Ver Menús',
		save_item_rejected: 'Guardar',
		finishOrder: 'Confirmar',
		remove: 'Eliminar',
		notes: 'Observaciones',
		noStay: 'El Servicio de Habitaciones no está disponible porque no hay una estadía en curso.',
		placedOrders: 'Pedidos Realizados',
		cancels: 'Cancelar',
		yourCart: 'Su carrito.',
		noPlacedOrders: 'No hay pedidos realizados.',
		revocerPassword: '¿Olvidó su contraseña?',
		item: 'Artículo',
		local: 'Local',
		date: 'Fecha',
		account_quantity: 'Cant.',
		value: 'Valor',
		reject: 'Rechazar',
		Noticia: 'Noticia',
		Questionario: 'Cuestionario',
		Voltar: 'Volver',
		Comentario: 'Comentario',
		Comentar: 'Comentar',
		Ver_mais: 'Ver Más',
		Saber_mais: 'Saber más',
		nao_foram_encontradas_noticias: 'No se encontraron noticias.',
		Todas: 'Todas',
		Comidas: 'Comidas',
		Bebidas: 'Bebidas',
		Outras: 'Otros',
		Filtro: 'Filtrar',
		Pesquisa: 'Buscar',
		Perfil: 'Perfil',
		Clube: 'Club',
		send_account_info: 'Enviar',
		reject_items_question: 'Por favor, indíquenos el motivo.',
		approved: 'Aprobado',
		to_send: 'Pendiente',
		rejected_at: 'Rechazado en',
		rejected: 'Rechazado',
		status: 'Estado',
		payments: 'Pagos',
		pago: 'Pagado',
		client_accounts: 'Cuentas de Cliente',
		client_account: 'Cuenta de Cliente',
		end_payment: 'Pago de Salida',
		account_no_items: 'No hay artículos para esta cuenta',
		Informations: 'Informaciones',
		Nao_existem_conteudos_hotel_selecionado: 'No hay contenido para el hotel seleccionado.',
		Selecione_hotel_ver_conteúdo: 'Seleccione un hotel para ver su contenido.',
		success_rsv_checkout: 'Check-out realizado con éxito.',
		account_no_items: 'No hay consumos registrados.',
		success_rsv_checkout: '¡Su salida se ha realizado con éxito!<br>Deje la(s) tarjeta(s) de llave de su(s) habitación(es) en la recepción en la caja designada.<br><br>Le agradecemos su preferencia y esperamos verlo pronto.',
		checkout_text_w_items: 'Hay valores abiertos en su reserva. Por favor, confirme que todo está correcto',
		checkout_text_no_items: 'Realice el check-out de forma rápida y sencilla. Haga clic en el botón a continuación:',
		checkout_warning: 'Por favor, diríjase a la recepción para realizar el check-out.',
		checkout_warning_w_rejected: 'Por favor, diríjase a la recepción para verificar su cuenta.',
		client_account_sentence: 'Por favor, confirme sus consumos durante su estadía en la lista a continuación.',
		confirmed_account_msg: 'Confirmación registrada con éxito.',
		discount: 'Descuento',
		checkout_done: 'Opción disponible solo cuando hay una estadía en curso.',
		appointments: 'Reservas',
		animation: 'Animación',
		laundry: 'Lavandería',
		associate_rsv: 'Asociar a una reserva existente',
		rsv_number: 'Nº de Reserva',
		your_rsv: 'Su Reserva',
		your_next_rsv: 'Su Próxima Reserva',
		room_number: 'Nº de Habitación',
		rsv_succed: 'Reserva creada con éxito.',
		str_hour_schedule: 'De {start_time} a {end_time}',
		bookings_no_items: 'No hay reservas registradas.',
		my_appointments: 'Mis Reservas',
		people_n: 'Nº de Personas',
		service: 'Servicio',
		service_type: 'Tipo de Servicio',
		horario: 'Horario',
		horarios: 'Horarios',
		space: 'Espacio',
		space_type: 'Tipo de Espacio',
		availability: 'Disponibilidad',
		type_of: 'Tipo de',
		dish: 'Plato',
		newa: 'Nueva',
		newo: 'Nuevo',
		cancelled: 'Cancelado',
		aviso: 'Aviso',
		yes: 'Sí',
		no: 'No',
		my_bookings_sentence: 'Consulte sus reservas en la lista a continuación.',
		Entretenimiento: 'Entretenimiento',
		Noticiass: 'Noticias',
		Eventos: 'Eventos',
		Eventoss: 'Eventos',
		payment_msg: 'Puede pagar los bienes y servicios consumidos ahora o más tarde, en la recepción del hotel.',
		consult: 'Consultar',
		no_spaces: 'No es posible hacer citas. Por favor, contacte con la recepción.',
		no_shedules: 'No hay horarios disponibles. Por favor, contacte con la recepción.',
		booking_removed: 'Reserva eliminada con éxito.',
		Configuration: 'Configuración',
		error: 'Error',
		VilaGaleSTAR: 'Vila Galé STAR',
		Inovar_Motivar: 'Inovar Motivar',
		check_cartas_login: '¿Quieres consultar nuestros menús?<br>Haz clic',
		check_entertainment_login: '¿Quieres consultar nuestros programas de entretenimiento?<br>Haz clic',
		here: 'aquí',
		Parcerias: 'Asociaciones',
		Parceriass: 'Asociaciones',
		Categorias: 'Categorías',
		Todos: 'Todos',
		payment_success: 'Pago exitoso',
		payment_pending: 'Valide su pago en la aplicación MBWay',
		hotel: 'Hotel',
		payment_pending: 'El pago está pendiente. Por favor, acceda a la aplicación y autorice el pago.',
		no_reservations_available: 'No hay reservas disponibles.',
		recover_1: 'Se han enviado sus datos de acceso a la dirección de correo electrónico',
		recover_2: 'Si no ha recibido nuestro correo electrónico (revise todas las carpetas, incluida la de Spam), haga clic',
		recover_3: 'para que se le envíe el correo electrónico nuevamente.',
		just_a_second: 'Solo un segundo...',
		recover_aqui: 'aquí',
		contact: 'Se produjo un error. Por favor, contáctenos.',
		recover_title: 'Recuperación de Contraseña',
		erro_date: 'Error con la fecha seleccionada.',
		new_password: 'Nueva Contraseña',
		new_password_desc: 'Debe cambiar su contraseña antes de iniciar sesión en ',
		password_changed: 'Su nueva contraseña ha sido registrada con éxito.',
		submeter: 'Enviar',
		missing_pass: 'El campo de «Contraseña» es obligatorio.',
		missing_conf_pass: 'El campo de «Confirmar contraseña» es obligatorio.',
		pass_not_match: 'Los campos de «Contraseña» y «Confirmar contraseña» no coinciden.',
		tipo_de_marcacao: 'Tipo de marcado',
		tipo_de_espaco: 'Tipo de habitación',
		data_do_registo: 'Fecha de Registro',
		mesas: 'Mesas',
		n_quarto: 'Habitación no.',
		grupo: 'Grupo',
		n_presenças: 'Número de asistencia',
		registado_por: 'Registrado por',
		observacoes: 'Comentarios',
		nome: 'Nombre',
		n_grupo: 'Nº Grupo',
		regime: 'Régimen',
		n_presencas: 'Número de asistencia',
		ver: 'Para ver',
		n_presencas_registado: 'Número de asistencias registradas con éxito.',
		erro_numero_distribuicao_reserva: 'Error - número de distribución de reserva',
		erro_numero_pessoas: 'Error - número de personas',
		erro_guardar_n_presencas: 'Error al guardar el Número de Asistencia.',
		Pesquisar: 'Buscar',
		obrigatorio_inserir_n_reserva_n_quarto: 'Es obligatorio introducir el Número de Reserva o Número de Habitación.',
		sair: 'Salir',
		Limpar: 'Limpiar',
		Grupos: 'Grupos',
		Passante: 'Transeúnte',
		Reserva: 'Reserva',
		Pessoas: 'Persona(s)',
		Houve_um_colega_que_se_destacou: '¿Hubo un colega que se destacó?',
		Nomeia_o_para_o_Vila_Gale_Star: '¡Nómbralo para el Vila Galé Star!',
		Todos_os_meses_e_eleito_um_vencedor: '¡Cada mes se elige un ganador!',
		Quem_sabe_se_tu_nao_seras_o_proximo: '¡Quién sabe si serás el próximo!',
		Ano: 'Año',
		Trimestre: 'Trimestre',
		Mes: 'Mes',
		Portugal: 'Portugal',
		E_a_cada_3_meses: 'Y, cada 3 meses,',
		havera_uma_decisao_com_premio: '¡habrá una decisión con premio!',
		Quem_sabe_se_es_o_proximo: '¡Quién sabe si eres el próximo!',
		Faz_nos_Brilhar: '¡Haznos Brillar!',
		Regulamento: 'Reglamento',
		Nomear: 'Nominar',
		Finalidade: 'Propósito',
		O_programa_visa_evidenciar_o_merito_do_desempenho_dos: 'El programa tiene como objetivo destacar el mérito del desempeño de los empleados, en un modelo de toma de decisiones participativa por parte de los demás miembros de la unidad o departamento.',
		Metodo: 'Método',
		O_programa_divide_se_em_4_fases: 'El programa se divide en 4 fases:',
		Mensal: 'Mensual',
		votacao: 'Votación',
		a_votacao_doa_vg_star_mensal_e_feita_atraves_das: 'La votación para el VG STAR Mensual se realiza a través de las nominaciones de los compañeros en los formularios del tablón de anuncios del ISL, MyVilaGalé y ERP, de los clientes a través de cuestionarios internos de satisfacción y otras plataformas digitales, y en una reunión de la dirección.',
		eleicao: 'Elección',
		a_eleicao_do_vg_star_mensal_e_feita_atraves_da: 'El VG STAR Mensual se elige sopesando las nominaciones de los compañeros (40%), las menciones de los clientes (40%) y en una reunión de dirección (20%). El ganador se anunciará el último día de cada mes. No habrá elección en diciembre.',
		premios: 'Premios',
		ao_vencedor_do_vg_star_mensal_e_atribuido: 'El ganador del VG STAR Mensual recibirá:',
		o_premio_de_5000_em_vale_valor_ivla_gale_carregados: 'El premio de 50,00 € en Vale Valor Vila Galé, cargados en el perfil ERP;',
		sera_divulgadoa_oa_vencedora_atraves: 'El ganador se anunciará a través del tablón de anuncios del ISL.',
		criterios_de_nao_eleicao: 'Criterios para NO ser elegido/a:',
		falta_injustificada_no_mes_da_nomeacao: 'Ausencia injustificada en el mes de nominación;',
		advertencia_por_escrito: 'Amonestación por escrito;',
		reclamacoes_com_o_seu_nome: 'Quejas a su nombre;',
		ter_sido_eleito_a_no_presente_trimestre: 'Haber sido elegido en el trimestre en curso.',
		trimestral: 'Trimestral',
		oa_vg_star_trimestral_sera_uma_dosas_colegas: 'El/la VG STAR Trimestral será uno de los compañeros de la misma unidad que hayan ganado el VG STAR Mensual en los 3 meses anteriores.',
		a_eleicao_do_vg_star_trimestral_e_feita_atraves: 'La elección del VG STAR Trimestral tiene lugar en una reunión de la dirección, teniendo en cuenta a los 3 compañeros ganadores de los meses anteriores. El ganador será notificado antes del día 15 del mes siguiente al final del trimestre, a excepción de diciembre. (15 de abril, 15 de julio, 15 de octubre, 5 de diciembre).',
		ao_vencedora_do_vg_star_trimestral_sao: 'El ganador del VG STAR Trimestral recibirá los siguientes premios:',
		em_vale_valor_carregados_no_profile_em_erp_50: '50,00 € en Vale Valor cargados en el perfil ERP (acumulables con los 50,00 € cargados en el VG STAR Mensual);',
		badge_com_estrela_que_devera_ser_utilizado_durante: 'Insignia con estrella para llevar durante todo el año;',
		sera_divulgado_a_o_a_vencedor_a_para_os_clientes: 'El ganador se dará a conocer a los clientes a través de la televisión de recepción y del portal MyVilaGalé.',
		falta_injustificada_no_trimestre: 'Ausencia injustificada en el trimestre;',
		advertencia_por_escrito: 'Amonestación por escrito;',
		atrasos_injustificados_no_trimestre: 'Retrasos injustificados en el trimestre;',
		altercacoes: 'Altercados;',
		ter_sido_nomeado_vg_star_trimestre_no_presente_ano: 'Haber sido nombrado VG STAR (trimestre) en el año en curso.',
		a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de: 'La elección del VG SUPERSTAR Hotel tiene lugar en una reunión de la dirección y se envía al departamento de RRHH (rh@vilagale.com) debidamente justificada antes del 7 de diciembre de cada año. El/la elegido/a debe ser uno/a de los VG STAR de los 4 trimestres.',
		aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios: 'El ganador del VG SUPERSTAR Hotel recibirá los siguientes premios:',
		em_vale_valor_carregados_no_profile_em_erp_100: '-	100,00 € en Vale Valor cargados en el perfil ERP;',
		sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL: 'El ganador se dará a conocer a través del tablón de anuncios del ISL y a los clientes a través de la televisión de la recepción y del portal MyVilaGalé.',
		todas_os_criterios_referidos_no_vg_star: 'Todos los criterios mencionados en el VG STAR;',
		nao_ter_sido_vencedora_do_vg_star: 'No haber sido ganador del VG STAR.',
		Nacional: 'National',
		oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos: 'El VG SUPERSTAR Nacional se organiza analizando los ganadores del VG SUPERSTAR de cada hotel.',
		a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri: 'El VG SUPERSTAR Nacional es elegido por un jurado compuesto por el Departamento de Operaciones, el Departamento de Administración y el Departamento Financiero.',
		ao_vencedor_do_vg_superstar_nacional_sao_atribuidos: 'El ganador de la VG SUPERSTAR Portugal recibirá los siguientes premios:',
		em_vale_valor_carregados_no_profile_em_erp_200: '200,00 € en Vale Valor cargados en el perfil ERP;',
		oa_vencedora_sera_convidadoa_a_estar_presente: 'El ganador será mencionado en el E-feel Staff, MyVilaGalé y WhatsApp;',
		sera_divulgado_o_vencedor_para_os_clientes: 'El ganador se dará a conocer a los clientes a través de la televisión de recepción y del portal MyVilaGalé.',
		todas_os_criterios_referidos_no_vg_star: 'Todos los criterios mencionados en el VG STAR;',
		nao_ter_sido_vencedor_a_do_vg_star: 'No haber sido ganador del VG STAR.',
		Nenhum_colaborador_encontrado: 'No se encontró ningún colaborador',
		O_campo_Colaborador_é_obrigatório: 'El campo Colaborador es obligatorio',
		O_campo_Motivo_é_obrigatório: 'El campo Motivo es obligatorio',
		Passou_o_limite_de_caracteres_para_o_campo_Motivo: 'Has superado el límite de caracteres para el campo Motivo',
		Nomeação_registada_com_sucesso: 'Gracias por su nominación.',
		Este_mês_já_fez_uma_nomeação: 'Este mes ya has hecho una nominación',
		SelecionarIdioma: 'Seleccionar Idioma',
		Idioma: 'Idioma',
		Nova: 'Nueva',
		Link: 'Enlace',
		Corporativo: 'Corporativo',
		PortuguêsPT: 'Portugués PT',
		PortuguêsBR: 'Portugués BR',
		O_tamanho_máximo_permitido_para_a_imagemé_de_200kb: 'El tamaño máximo permitido para la imagen es de 200kb',
		As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório: 'Las dimensiones de la imagen deben ser 500px x 500px (obligatorio)',
		Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif: 'Las imágenes deben ser del tipo \'.jpg\', \'.jpeg\', \'.png\' o \'.gif\'',
		O_campo_Idioma_é_obrigatório: 'El campo Idioma es obligatorio',
		O_campo_Hotel_é_obrigatório: 'El campo Hotel es obligatorio',
		Registo_criado_com_sucesso: 'Registro creado con éxito',
		Ocorreu_um_erro_ao_criar_o_registo: 'Ocurrió un error al crear el registro',
		Registo_eliminado_com_sucesso: 'Registro eliminado con éxito',
		Ocorreu_um_erro_ao_eliminar_o_registo: 'Ocurrió un error al eliminar el registro',
		INOVAR: "INNOVAR",
		MOTIVAR: "MOTIVAR",
		Inovar_Motivar: "Innovar Motivar",
		Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar: "Participa en el programa Innovar Motivar y califícate para ganar 75€.",
		Vamos_contribuir_para_a_mudança_do_nosso_grupo: "¡Contribuyamos al cambio de nuestro grupo!",
		Inova_e_Ganha: "¡Innova y Gana!",
		Participar: "Participar",
		O_programa_visa_incentivar_a_participação_de_todos_no: "El programa tiene como objetivo incentivar la participación de todos en el desarrollo de la empresa, valorando sus ideas y sugerencias, y crear una mayor implicación y conexión entre todos los empleados y Vila Galé.",
		As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada: "Las ideas o sugerencias recibidas hasta el final de cada trimestre serán evaluadas por un VG LAB.",
		Para_participar_basta_preencher_o_formulário_em_papel: "Para participar, simplemente complete el formulario en papel o en línea (ERP/My Vila Galé).",
		As_ideias_apresentadas_serão_classificadas_em: "Las ideas presentadas se clasificarán en 3 criterios:",
		Relevantes_e_finalizadas_para_implementação_premiadas: "Relevantes y finalizadas para implementación - premiadas;",
		Desenvolvimento_o_a_colaborador_a_será_convidado: "Desarrollo - el/la colaborador/a será invitado/a a mejorar su idea para que sea factible;",
		Não_relevantes: "No relevantes.",
		A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor: "Las ideas premiadas reciben un premio por valor de 75€ en tarjeta Sonae o 100€ en Vale Incentivo VG.",
		Fatores_eliminatórios_apenas_a_sugestão_ou_ideia: "Factores eliminatorios (solo la sugerencia o idea adecuada a los mismos permitirá su nominación):",
		Inovação_e_originalidade: "Innovación y originalidad",
		Valor_acrescentado_para_a_empresa: "Valor añadido para la empresa",
		Necessidade_de_implementação: "Necesidad de implementación",
		Exequibilidade_operacional: "Factibilidad operativa",
		Método_de_implementação: "Método de implementación",
		Custos_de_implementação: "Costos de implementación",
		As_ideias_ou_sugestões_relevantes_não_serão_premiadas: "Las ideas o sugerencias relevantes no serán premiadas en una primera etapa, pero podrán serlo después del desarrollo por parte del/la colaborador/a.",
		Em_caso_de_ideias_similares_apenas_uma_será_premiada: "En caso de ideas similares, solo una será premiada. Obedeciendo al siguiente orden de elección:",
		Mais_critérios_eliminatórios_adequados: "Más criterios eliminatorios adecuados;",
		Custos_de_implementação_calculados: "Costos de implementación calculados;",
		Data_de_submissão: "Fecha de presentación.",
		Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir: "El VG LAB evaluador se reserva el derecho de no otorgar premios si no se ha presentado ninguna idea o si las ideas presentadas no cumplen con las condiciones para la adjudicación de premios.",
		Colaborador: "Colaborador",
		Motivo: "Motivo",
		Assunto: "Asunto",
		Categoria: "Categoría",
		Descrição: "Descripción",
		Ficheiro: "Archivo",
		Imagem: "Imagen",
		Tipo: "Tipo",
		Não_foram_encontradas_cartas_para_o_hotel_selecionado: "No se encontraron cartas para el hotel seleccionado.",
		Menu: "Menú",
		Directório: "Directorio",
		Marcação: "Marcación",
		Capitulo: "Capítulo",
		Erro_nos_subcapitulos: "Error en los subcapítulos.",
		Carta_copiada_com_sucesso: "Carta copiada con éxito.",
		Erro_a_gravar: "Error al guardar",
		O_campo_Hotel_é_obrigatório: "El campo Hotel es obligatorio.",
		Deseja_mesmo_apagar: "¿Desea realmente eliminar?",
		Pretende_eliminar: "Pretende eliminar",
		Erro_a_obter_hoteis: "Error al obtener hoteles",
		Visivel: "Visible",
		Nome_Impressão: "Nombre de impresión",
		Informação: "Información",
		moeda: "moneda",
		Moeda: "Moneda",
		armazem: "almacén",
		Armazém: "Almacén",
		Remover_Imagem: "Eliminar imagen",
		Adicionar_Imagem: "Añadir imagen",
		As_dimensões_da_imagem_devem_ser_800px_x_600px: "Las dimensiones de la imagen deben ser 800px x 600px (obligatorio).",
		Esta_carta_já_foi_registada: "Esta carta ya ha sido registrada.",
		Registo_alterado_com_sucesso: "Registro modificado con éxito",
		Registo_criado_com_sucesso: "Registro creado con éxito.",
		Ocorreu_um_erro_ao_alterar_o_registo: "Ocurrió un error al modificar el registro",
		Ocorreu_um_erro_ao_criar_o_registo: "Ocurrió un error al crear el registro.",
		O_campo_Nome_é_obrigatório_no_idioma: "El campo Nombre es obligatorio en el idioma",
		O_campo_Moeda_é_obrigatório: "El campo Moneda es obligatorio.",
		O_campo_Armazém_é_obrigatório: "El campo Almacén es obligatorio.",
		O_campo_Categoria_é_obrigatório: "El campo Categoría es obligatorio.",
		Ocorreu_um_erro: "Ocurrió un error.",
		Artigo_de_Venda: "Artículo de Venta",
		Este_menu_já_foi_registado: "Este menú ya ha sido registrado.",
		Ordem_n: "Orden (º)",
		Adicionar: "Añadir",
		Não_foram_encontrados_capítulos: "No se encontraron capítulos.",
		O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a: "El campo Orden debe ser numérico y mayor o igual a 0.",
		O_campo_Nome_é_obrigatório: "El campo Nombre es obligatorio.",
		Medidas: "Medidas",
		Artigo_de_Venda: "Artículo de Venta",
		Atualizar: "Actualizar",
		Não_foram_encontrados_subcapítulos: "No se encontraron subcapítulos",
		Litro: "Litro",
		Decilitro: "Decilitro",
		Centilitro: "Centilitro",
		Mililitro: "Mililitro",
		Minuto: "Minuto",
		Não_foram_encontrados_capítulos_para_o_idioma_seleccionado: "No se encontraron capítulos para el idioma seleccionado.",
		O_campo_Quantidade_é_obrigatório: "El campo Cantidad es obligatorio.",
		O_campo_Medida_é_obrigatório: "El campo Medida es obligatorio.",
		O_campo_Preço_deve_ser_numérico: "El campo Precio debe ser numérico.",
		O_campo_Preço_é_obrigatório_e_deve_ser_numérico: "El campo Precio es obligatorio y debe ser numérico.",
		Não_foram_adicionadas_medidas: "No se han añadido medidas.",
		O_campo_Preço_é_obrigatório: "El campo Precio es obligatorio.",
		Zonas: "Zonas",
		Data_de_Validade: "Fecha de Caducidad",
		Upload: "Subir",
		Destaque: "Destacado",
		Pública: "Pública",
		Privada: "Privada",
		Resposta1: "1 Respuesta",
		Várias_Opções: "Varias Opciones",
		Resposta: "Respuesta",
		A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif: "La imagen debe ser del tipo jpeg, jpg, png o gif",
		O_ficheiro_tem_de_ser_um_pdf: "El archivo debe ser un PDF.",
		Lista_de_Notícias: "Lista de Noticias",
		Autor: "Autor",
		Detalhe: "Detalle",
		Data_Inicio: "Fecha de Inicio",
		Data_Fim: "Fecha de Fin",
		Evento_apagado: "Evento borrado.",
		Deseja_mesmo_apagar_o_evento: "¿Desea realmente borrar el evento?",
		Apagar: "Borrar",
		O_evento_será_apagado_e_não_será_possível_recuperá_lo: "El evento {name} será borrado y no se podrá recuperar.",
		Privado: "Privado",
		Não_é_possível_visualizar_o_documento: "No es posible visualizar el documento.",
		Já_chegou_ao_limite_de_ficheiros: "Ha llegado al límite de archivos.",
		Apenas_são_aceites_PDFs_documentos_Word_ou_imagens: "Solo se aceptan PDFs, documentos de Word o imágenes en formato jpeg, jpg o png.",
		O_ficheiro_não_pode_ter_mais_de_10mb: "El archivo no puede tener más de 10mb.",
		O_campo_Assunto_é_obrigatório: "El campo Asunto es obligatorio.",
		O_campo_Categoria_é_obrigatório: "El campo Categoría es obligatorio.",
		O_campo_Descrição_é_obrigatório: "El campo Descripción es obligatorio.",
		Passou_o_limite_de_caracteres_para_o_campo_Descrição: "Ha superado el límite de caracteres para el campo Descripción.",
		Participação_registada_com_sucesso: "Participación registrada con éxito.",
		Este_directório_já_foi_registado: "Este directorio ya ha sido registrado.",
		Só_é_permitido_um_directório_por_hotel: "Solo se permite un directorio por hotel.",
		Ficheiros: "Archivos",
		Data_de_Início: "Fecha de Inicio",
		Data_de_Fim: "Fecha de Fin",
		A_Data_de_Início_não_está_selecionada: "La Fecha de Inicio no está seleccionada.",
		A_Data_de_Fim_não_está_selecionada: "La Fecha de Fin no está seleccionada.",
		Titulo: "Título"
	},
	// Lang ES




	// Lang FR
	fr: {
		fromOurTradition: 'De notre tradition',
		description: 'Description',
		price: 'Prix',
		restaurantFood: 'Restaurant Val Moreira | Nourriture',
		restaurantDrinks: 'Restaurant Val Moreira | Boissons',
		appetizers: 'Apéritifs',
		appetizer_one: 'Green asparagus cream soup, crispy traditional smoked sausage and chives',
		appetizer_two: 'Our traditional green broth',
		appetizer_three: 'Fresh cheese salad with peach, smoked ham and almonds',
		appetizer_four: 'Grilled rustic bread with olive oil and garlic, traditional Lamego smoked sausage and quail egg',
		appetizer_five: 'Shrimps in tempura, mango, kiwi chutney, sweet chili and salad sprouts',
		dish_monday: 'Deep-fried meat-filled pastries with lima beans rice',
		dish_tuesday: 'Octopus fillets with broccoli rabe rice',
		dish_wednesday: 'Old-fashioned style duck rice',
		dish_thursday: 'Cod loins roasted with onions and boiled potatoes',
		dish_friday: 'Game meat pie with sautéed spinach',
		dish_saturday: 'Cavado river trouts with smoked ham and boiled potatoes',
		dish_sunday: 'Roast kid with potatoes and sautéed broccoli rabe',
		Cliente: 'Client',
		Orders: 'Service de chambre',
		account: 'Compte',
		Estadia: 'Séjour',
		Checkin: 'Enregistrement en ligne',
		vSelectNoResults: 'Aucun résultat trouvé.',
		vSelectNoOptions: 'Aucune option disponible',
		EstadiasAnteriores: 'Séjours passés',
		QuestionarioSatisfacao: 'Questionnaires',
		InstantFeedback: 'Retour instantané',
		Cartas: 'Carte',
		Capitulo: 'Chapitre',
		Chapters: 'Chapitres',
		Subcapitulos: 'Sous-chapitre',
		MenuSetup: 'Configuration',
		Restauracao: 'Menus',
		RestauranteValMoreiraComida: 'Restaurant Val Moreira | Menu',
		RestauranteValMoreiraBebidas: 'Restaurant Val Moreira | Boissons',
		BarValMoreira: 'Bar Val Moreira',
		PequenoAlmoco: 'Petit-déjeuner',
		ChaDas5: 'Thé de 5 heures',
		MenuNep: 'Menu NEP',
		VinhosAdega: 'Vins / Cave',
		Gins: 'Gins',
		Servicos: 'Services',
		Piscina: 'Piscine',
		Lavandaria: 'Blanchisserie',
		Minibar: 'Minibar',
		VinhosAzeites: 'Vins / Huile d\'olive',
		RoomService: 'Service de chambre',
		Spa: 'Spa',
		DirectorioAZ: 'Annuaire A-Z',
		IvaCorrente: 'TVA incluse au taux actuel.',
		LivroReclamacoes: 'Cet établissement dispose d\'un livre de réclamations.',
		PrevencaoAlergias: 'Pour la prévention des allergies potentielles, il existe une fiche technique décrivant les ingrédients utilisés. Aucun plat, aliment ou boisson, y compris le couvert, ne peut être facturé s\'il n\'est pas demandé par le client ou s\'il est rendu inutilisable.',
		PrevencaoIncendios: 'Prévention des incendies',
		EstadiaActual: 'Votre séjour actuel',
		ContaDeQuarto: 'Votre facture de chambre actuelle',
		pontoDeVenda: 'Point de vente',
		dataHora: 'Date',
		artigoFactura: 'Article facturé',
		amount: 'Montant',
		billConfirmation: 'Confirmé',
		SuasEstadiasAnteriores: 'Vos séjours passés',
		WakeUp: 'Service de réveil',
		naoPerturbar: 'Service Ne pas déranger',
		suporte: 'Maintenance',
		Produtos: 'Produits',
		Welcome_M: 'Bienvenue',
		Welcome_F: 'Bienvenue',
		gerirConteudos: 'Gérer les contenus',
		gerirUtilizadores: 'Gérer les permissions',
		pesquisarUtilizador: 'Rechercher un utilisateur',
		Administracao: 'Gestion',
		editUserRole: 'Modifier les permissions',
		insertUserId: 'Email, Id ou Nom',
		Gravar: 'Enregistrer',
		roleActual: 'Permission',
		roleSuccess: 'Rôle changé avec succès.',
		gerirConteudoMain: 'Gérer le contenu de la page principale',
		directorio: 'Annuaire',
		main_page: 'Page d\'accueil',
		edit_hotel: 'Sélectionnez l\'hôtel à éditer :',
		current_hotel: 'Hôtel actuel',
		select_hotel: 'Sélectionner l\'hôtel',
		corporate_images: 'Images d\'entreprise',
		password: 'Mot de passe',
		register: 'S\'inscrire',
		user: 'Utilisateur',
		user_email: 'Nom d\'utilisateur ou Email',
		invalid_credentials: 'Identifiants invalides',
		attention: 'Attention.',
		mandatory_user: 'Le champ utilisateur est obligatoire.',
		mandatory_password: 'Le champ mot de passe est obligatoire.',
		login_password: 'Les champs utilisateur et mot de passe sont obligatoires.',
		error_password: 'Mot de passe invalide.',
		added_item_to_cart: 'Article ajouté au panier avec succès.',
		order_placed: 'Votre commande a été passée avec succès.',
		success: 'Succès.',
		order_error: 'Une erreur est survenue lors de la passation de votre commande, veuillez réessayer.',
		user_not_found: 'Aucun enregistrement trouvé.',
		empty_search_filed: 'Le champ de recherche ne peut pas être vide.',
		en: 'Anglais',
		pt: 'Portugais',
		br: 'Portugais',
		de: 'Allemand',
		fr: 'Français',
		es: 'Espanol',
		dont_show_popup: "Ne plus afficher ce message.",
		empty_feedback: 'Il y a des questions sans réponse sélectionnée.',
		feedback_comments: 'Commentaires (facultatif)',
		feedback_thanks: 'Merci pour votre retour.',
		noFeedback: 'Retour instantané indisponible car il n\'y a pas de séjour en cours.',
		submit: 'Soumettre',
		long_comment_feedback: 'Vos commentaires ont dépassé la limite de caractères.',
		corporate_banners: 'Groupe Vila Galé',
		changeRole: 'Rôle changé avec succès.',
		addRole: 'Rôle ajouté avec succès.',
		removeRole: 'Rôle supprimé avec succès.',
		instantFeedback: 'Retour instantané',
		noAvailableFeedback: 'Retour instantané indisponible car il n\'y a pas de séjour en cours.',
		legalNotice: 'Mentions légales',
		legalNoticeUrl: 'https://www.vilagale.com/fr/politique-de-confidentialite',
		privacyPolicy: 'Politique de confidentialité',
		privacyPolicyUrl: 'https://www.vilagale.com/fr/avertissement-legal',
		complaintsBook: 'Livre de réclamations',
		complaintsBookUrl: 'https://www.livroreclamacoes.pt/inicio/',
		Noticias: 'Actualités',
		Carta: 'Menu',
		Cartas: 'Menus',
		noCheckin: 'Il n\'y a pas de réservations pour l\'enregistrement en ligne.',
		noSurvey: 'Il n\'y a pas de questionnaires à répondre.',
		questionnaires: 'Questionnaires',
		reservation: 'Réservation',
		answer: 'Répondre',
		open: 'Ouvrir',
		CartasSide: 'Menus',
		noOrders: 'Il n\'y a aucune commande passée',
		emptyCart: 'Votre panier est vide.',
		returnButton: 'Revenir',
		description: 'Description',
		noMenus: 'Il n\'y a pas de menus disponibles.',
		noItems: 'There are no items available.',
		noChapter: 'Le menu n\'est pas disponible.',
		noDirectory: 'Directory A-Z not available.',
		noDirectoryLang: 'Directory A-Z not available for this language.',
		noItemsAvailable: 'Il n\'y a pas d\'articles disponibles.',
		quantity: 'Quantité',
		noItemsInCart: 'Il n\'y a aucun article dans votre panier.',
		seeMenus: 'Voir les menus',
		save_item_rejected: 'Enregistrer',
		finishOrder: 'Confirmer',
		remove: 'Supprimer',
		notes: 'Observations',
		noStay: 'Service de chambre indisponible car il n\'y a pas de séjour en cours.',
		placedOrders: 'Commandes passées',
		cancels: 'Annuler',
		yourCart: 'Votre panier.',
		noPlacedOrders: 'Il n\'y a aucune commande passée.',
		revocerPassword: 'Mot de passe oublié ?',
		item: 'Article',
		local: 'Local',
		date: 'Date',
		account_quantity: 'Qté.',
		value: 'Valeur',
		reject: 'Rejeter',
		Noticia: 'Actualité',
		Questionario: 'Questionnaire',
		Voltar: 'Retour',
		Comentario: 'Commentaire',
		Comentar: 'Commenter',
		Ver_mais: 'Voir plus',
		Saber_mais: 'En savoir plus',
		nao_foram_encontradas_noticias: 'Aucune actualité trouvée.',
		Todas: 'Tout',
		Comidas: 'Aliments',
		Bebidas: 'Boissons',
		Outras: 'Autres',
		Filtro: 'Filtre',
		Pesquisa: 'Recherche',
		Perfil: 'Profil',
		Clube: 'Club',
		send_account_info: 'Envoyer',
		reject_items_question: 'Veuillez nous dire pourquoi.',
		approved: 'Approuvé',
		to_send: 'En attente',
		rejected_at: 'Rejeté le',
		rejected: 'Rejeté',
		status: 'Statut',
		payments: 'Paiement',
		pago: 'Payé',
		client_accounts: 'Comptes client',
		client_account: 'Compte client',
		end_payment: 'Paiement à la sortie',
		account_no_items: 'Il n\'y a aucun article pour ce compte',
		Informations: 'Informations',
		Nao_existem_conteudos_hotel_selecionado: 'Il n\'y a aucun contenu pour l\'hôtel sélectionné.',
		Selecione_hotel_ver_conteúdo: 'Sélectionnez un hôtel pour voir son contenu.',
		success_rsv_checkout: 'Check-out effectué avec succès.',
		account_no_items: 'Il n\'y a aucun consommation enregistrée.',
		success_rsv_checkout: 'Votre départ a été effectué avec succès!<br>Laissez la carte clé de votre/vos chambre(s) à la réception dans la boîte prévue à cet effet.<br><br>Nous vous remercions pour votre préférence et nous espérons vous revoir bientôt!',
		checkout_text_w_items: 'Il y a des montants ouverts dans votre réservation. Veuillez confirmer que tout est correct',
		checkout_text_no_items: 'Check-out rapide et facile. Cliquez sur le bouton ci-dessous :',
		checkout_warning: 'Veuillez vous rendre à la réception pour effectuer votre check-out.',
		checkout_warning_w_rejected: 'Veuillez vous rendre à la réception pour vérifier votre facture.',
		client_account_sentence: 'Veuillez confirmer vos consommations pendant votre séjour dans la liste ci-dessous.',
		confirmed_account_msg: 'Confirmation enregistrée avec succès.',
		discount: 'Remise',
		checkout_done: 'Option disponible uniquement lorsqu\'il y a un séjour en cours.',
		appointments: 'Réservations',
		animation: 'Animation',
		laundry: 'Blanchisserie',
		associate_rsv: 'Lier à une réservation existante',
		rsv_number: 'Numéro de réservation',
		your_rsv: 'Votre Réservation',
		your_next_rsv: 'Votre Prochaine Réservation',
		room_number: 'Chambre Nº',
		rsv_succed: 'Réservation créée avec succès.',
		str_hour_schedule: 'De {start_time} à {end_time}',
		bookings_no_items: 'Il n\'y a aucune réservation enregistrée.',
		my_appointments: 'Mes Réservations',
		people_n: 'Nº de personnes',
		service: 'Service',
		service_type: 'Type de service',
		horario: 'Heure',
		horarios: 'Heures',
		space: 'Espace',
		space_type: 'Type d\'espace',
		availability: 'Disponibilité',
		type_of: 'Type de',
		dish: 'Plat',
		newa: 'Nouveau',
		newo: 'Nouveau',
		cancelled: 'Annulé',
		aviso: 'Avis',
		yes: 'Oui',
		no: 'Non',
		my_bookings_sentence: 'Consultez vos réservations dans la liste ci-dessous.',
		Entretenimento: 'Divertissement',
		Noticiass: 'Actualités',
		Eventos: 'Événements',
		Eventoss: 'Événements',
		payment_msg: "Vous pouvez payer les biens et services consommés maintenant ou plus tard, à la réception de l'hôtel.",
		consult: 'Consulter',
		no_spaces: "Il n'est pas possible de prendre rendez-vous. Veuillez contacter la réception.",
		no_shedules: 'Aucun horaire disponible. Veuillez contacter la réception.',
		booking_removed: 'Réservation supprimée avec succès.',
		Configuration: 'Configuration',
		error: 'Erreur',
		VilaGaleSTAR: 'Vila Galé STAR',
		Inovar_Motivar: 'Innover Motiver',
		check_cartas_login: 'Souhaitez-vous consulter nos menus ?<br>Cliquez',
		check_entertainment_login: 'Souhaitez-vous consulter nos programmes de divertissement ?<br>Cliquez',
		here: 'ici',
		Parcerias: 'Partenariats',
		Parceriass: 'Partenariats',
		Categorias: 'Catégories',
		Todos: 'Tous',
		payment_success: 'Paiement réussi',
		hotel: 'Hôtel',
		payment_pending: 'Le paiement est en attente. Veuillez accéder à l\'application et autoriser le paiement.',
		no_reservations_available: 'Aucune réservation disponible.',
		recover_1: 'Vos informations de connexion ont été envoyées à l\'adresse de courrier électronique',
		recover_2: '. Si vous n\'avez pas reçu notre courriel (vérifiez tous les dossiers, y compris le dossier de Spam), cliquez',
		recover_3: 'pour que le courriel soit envoyé à nouveau.',
		just_a_second: 'Juste une seconde...',
		recover_aqui: 'ici',
		contact: 'Une erreur est survenue. Contactez nous s\'il vous plait.',
		recover_title: 'Récupération de mot de passe',
		erro_date: 'Erreur avec la date sélectionnée.',
		new_password: 'Nouveau Mot de Passe',
		new_password_desc: 'Vous devez changer votre mot de passe avant de vous connecter à ',
		password_changed: 'Votre nouveau mot de passe a été enregistré avec succès.',
		submeter: 'Envoyer',
		missing_pass: 'Le champ « Mot de passe » est obligatoire.',
		missing_conf_pass: 'Le champ « Confirmation du mot de passe » est obligatoire.',
		pass_not_match: 'Les champs « Mot de passe » et « Confirmation du mot de passe » ne correspondent pas.',
		tipo_de_marcacao: 'Type de marquage',
		tipo_de_espaco: 'Type d\'espace',
		data_do_registo: 'Date d\'inscription',
		mesas: 'Les tables',
		n_quarto: 'Chambre numéro',
		grupo: 'Groupe',
		n_presenças: 'Nombre de présences',
		registado_por: 'Enregistré par',
		observacoes: 'Commentaires',
		nome: 'Nom',
		n_grupo: 'Numéro de groupe',
		regime: 'Régime',
		n_presencas: 'Nombre de présences',
		ver: 'Voir',
		n_presencas_registado: 'Nombre de passes décisives enregistrées avec succès.',
		erro_numero_distribuicao_reserva: 'Erreur - numéro de distribution de réservation',
		erro_numero_pessoas: 'Erreur - nombre de personnes',
		erro_guardar_n_presencas: 'Erreur lors de l\'enregistrement du numéro d\'assistance.',
		Pesquisar: 'Recherche',
		obrigatorio_inserir_n_reserva_n_quarto: 'Il est obligatoire d\'insérer le numéro de réservation ou le numéro de chambre.',
		sair: 'Sortir',
		Limpar: 'Nettoyer',
		Grupos: 'Groupes',
		Passante: 'Passant',
		Reserva: 'Réserve',
		Pessoas: 'Personne(s)',
		Houve_um_colega_que_se_destacou: 'Y a-t-il eu un collègue qui s\'est démarqué?',
		Nomeia_o_para_o_Vila_Gale_Star: 'Nommez-le pour le Vila Galé Star!',
		Todos_os_meses_e_eleito_um_vencedor:'Chaque mois, un gagnant est élu !',
		Quem_sabe_se_tu_nao_seras_o_proximo:'Qui sait, peut-être que ce sera toi le prochain !',
		Ano:'Année',
		Trimestre:'Trimestre',
		Mes:'Mois',
		Portugal: 'Portugal',
		E_a_cada_3_meses: 'Et, tous les 3 mois,',
		havera_uma_decisao_com_premio: 'il y aura une décision avec prix!',
		Quem_sabe_se_es_o_proximo: 'Qui sait si c\'est toi le prochain!',
		Faz_nos_Brilhar: 'Fais-nous Briller!',
		Regulamento: 'Règlement',
		Nomear: 'Nommer',
		Finalidade: 'Finalité',
		O_programa_visa_evidenciar_o_merito_do_desempenho_dos: 'Le programme vise à mettre en évidence le mérite de la performance des collaborateurs, dans un modèle de décision participative par les autres membres de l\'unité ou du département.',
		Metodo: 'Méthode',
		O_programa_divide_se_em_4_fases: 'Le programme se divise en 4 phases:',
		Mensal: 'Mensuel',
		votacao: 'Vote',
		a_votacao_doa_vg_star_mensal_e_feita_atraves_das: 'Le vote du VG STAR Mensuel se fait via les nominations des collègues sur les formulaires du tableau de l\'ISL, My Vila Galé et ERP, des clients via des questionnaires internes de satisfaction et d\'autres plateformes digitales, et en réunion de direction.',
		eleicao: 'Élection',
		a_eleicao_do_vg_star_mensal_e_feita_atraves_da: 'L\'élection du VG STAR Mensuel se fait via la pondération des nominations des collègues (40%), les mentions des clients (40%) et la réunion de direction (20%). Le(a) gagnant(e) doit être communiqué(e) le dernier jour de chaque mois. En décembre, il n\'y aura pas d\'élection.',
		premios: 'Prix',
		ao_vencedor_do_vg_star_mensal_e_atribuido: 'Au(à la) gagnant(e) du VG STAR Mensuel est attribué:',
		o_premio_de_5000_em_vale_valor_ivla_gale_carregados: 'Le prix de 50,00€ en Vale Valor Vila Galé, chargés sur le profil en ERP;',
		sera_divulgadoa_oa_vencedora_atraves: 'Le(la) gagnant(e) sera annoncé(e) via le tableau de l\'ISL.',
		criterios_de_nao_eleicao: 'Critères de NON-élection',
		falta_injustificada_no_mes_da_nomeacao: 'Absence injustifiée le mois de la nomination;',
		advertencia_por_escrito: 'Avertissement écrit;',
		reclamacoes_com_o_seu_nome: 'Réclamations à son nom;',
		ter_sido_eleito_a_no_presente_trimestre: 'Avoir été élu(e) au présent trimestre.',
		trimestral: 'Trimestriel',
		oa_vg_star_trimestral_sera_uma_dosas_colegas: 'Le(la) VG STAR Trimestriel(le) sera un(e) des collègues de la même unité gagnants du VG STAR Mensuel les 3 mois précédents.',
		a_eleicao_do_vg_star_trimestral_e_feita_atraves: 'L\'élection du VG STAR Trimestriel se fait par réunion de direction en considérant les 3 collègues gagnants des mois précédents. Le(la) gagnant(e) sera communiqué(e) avant le 15 du mois suivant la fin du trimestre, sauf en décembre (15 avril, 15 juillet, 15 octobre, 5 décembre).',
		ao_vencedora_do_vg_star_trimestral_sao: 'Au(à la) gagnant(e) du VG STAR Trimestriel sont attribués les prix:',
		em_vale_valor_carregados_no_profile_em_erp_50: '50,00€ en Vale Valor chargés sur le profil en ERP (à cumuler avec les 50,00€ chargés pour le VG Star Mensuel);',
		badge_com_estrela_que_devera_ser_utilizado_durante: 'Badge avec étoile à porter toute l\'année;',
		sera_divulgado_a_o_a_vencedor_a_para_os_clientes: 'Le(la) gagnant(e) sera annoncé(e) aux clients via la télévision de la réception et le portail My Vila Galé.',
		falta_injustificada_no_trimestre: 'Absence injustifiée au trimestre;',
		advertencia_por_escrito: 'Avertissement écrit;',
		atrasos_injustificados_no_trimestre: 'Retards injustifiés au trimestre;',
		altercacoes: 'Altercations;',
		ter_sido_nomeado_vg_star_trimestre_no_presente_ano: 'Avoir été nommé VG STAR (trimestre) au cours de l\'année.',
		a_eleicao_do_vg_superstar_hotel_e_feita_atraves_de: 'L\'élection du VG SUPERSTAR Hotel se fait lors d\'une réunion de direction jusqu\'au 5 décembre de chaque année. L\'élu(e) doit être l\'un(e) des VG STAR des quatre trimestres.',
		aoa_vencedora_do_vg_superstar_hotel_sao_atribuidos_os_premios: 'Au(à la) gagnant(e) du VG SUPERSTAR Hotel sont attribués les prix',
		em_vale_valor_carregados_no_profile_em_erp_100: '100,00€ en Vale Valor chargés sur le profil en ERP',
		um_cabaz_de_Natal_e_osas_vencedoresas_serão_anunciados: 'un panier de Noël et les gagnants seront annoncés lors de la fête de Noël',
		sera_divulgadoa_oa_vencedora_atraves_do_placard_do_ISL: 'Le(la) gagnant(e) sera annoncé(e) via le tableau de l\'ISL et aux clients via la télévision de la réception et le portail My Vila Galé',
		todas_os_criterios_referidos_no_vg_star: 'Tous les critères mentionnés dans le VG STAR;',
		nao_ter_sido_vencedora_do_vg_star: 'Ne pas avoir été gagnant(e) du VG STAR.',
		Nacional: 'National',
		oa_vg_superstar_nacional_e_feita_atraves_da_analise_dos: 'Le(la) VG SUPERSTAR National est choisi(e) après analyse des gagnants du VG SUPERSTAR de chaque hôtel',
		a_eleicao_do_vg_superstar_nacional_e_feita_por_um_juri: 'L\'élection du VG SUPERSTAR National est réalisée par un jury composé de la Direction des Opérations, de l\'Administration et de la Direction Financière.',
		ao_vencedor_do_vg_superstar_nacional_sao_atribuidos: 'Au(à la) gagnant(e) du VG SUPERSTAR National sont attribués les prix',
		em_vale_valor_carregados_no_profile_em_erp_200: '200,00€ en Vale Valor chargés sur le profil en ERP;',
		oa_vencedora_sera_convidadoa_a_estar_presente: 'Le(la) gagnant(e) sera invité(e) à être présent(e) à la Convention Annuelle du groupe et sera mentionné(e) dans E-feel Staff, My Vila Galé et sur Whatsapp;',
		sera_divulgado_o_vencedor_para_os_clientes: 'Le(la) gagnant(e) sera annoncé(e) aux clients via la télévision de la réception et le portail My Vila Galé.',
		todas_os_criterios_referidos_no_vg_star: 'Tous les critères mentionnés dans VG STAR;',
		nao_ter_sido_vencedor_a_do_vg_star: 'Ne pas avoir été gagnant(e) du VG STAR.',
		Nenhum_colaborador_encontrado: 'Aucun collaborateur trouvé',
		O_campo_Colaborador_é_obrigatório: 'Le champ Collaborateur est obligatoire',
		O_campo_Motivo_é_obrigatório: 'Le champ Motif est obligatoire',
		Passou_o_limite_de_caracteres_para_o_campo_Motivo: 'Vous avez dépassé la limite de caractères pour le champ Motif',
		Nomeação_registada_com_sucesso: 'Merci pour votre nomination.',
		Este_mês_já_fez_uma_nomeação: 'Ce mois-ci, vous avez déjà fait une nomination',
		SelecionarIdioma: 'Sélectionner la Langue',
		Idioma: 'Langue',
		Nova: 'Nouvelle',
		Link: 'Lien',
		Corporativo: 'Corporatif',
		PortuguêsPT: 'Portugais PT',
		PortuguêsBR: 'Portugais BR',
		O_tamanho_máximo_permitido_para_a_imagemé_de_200kb: 'La taille maximale autorisée pour l\'image est de 200ko',
		As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório: 'Les dimensions de l\'image doivent être de 500px x 500px (obligatoire)',
		Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif: 'Les images doivent être du type \'.jpg\', \'.jpeg\', \'.png\' ou \'.gif\'',
		O_campo_Idioma_é_obrigatório: 'Le champ Langue est obligatoire',
		O_campo_Hotel_é_obrigatório: 'Le champ Hôtel est obligatoire',
		Registo_criado_com_sucesso: 'Enregistrement créé avec succès',
		Ocorreu_um_erro_ao_criar_o_registo: 'Une erreur s\'est produite lors de la création de l\'enregistrement',
		Registo_eliminado_com_sucesso: 'Enregistrement supprimé avec succès',
		Ocorreu_um_erro_ao_eliminar_o_registo: 'Une erreur s\'est produite lors de la suppression de l\'enregistrement',
		INOVAR: "INNOVER",
		MOTIVAR: "MOTIVER",
		Inovar_Motivar: "Innover Motiver",
		Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar: "Participe au programme Innover Motiver et qualifiez-vous pour gagner 75€.",
		Vamos_contribuir_para_a_mudança_do_nosso_grupo: "Contribuons au changement de notre groupe!",
		Inova_e_Ganha: "Innover et Gagner!",
		Participar: "Participer",
		O_programa_visa_incentivar_a_participação_de_todos_no: "Le programme vise à encourager la participation de tous au développement de l'entreprise, en valorisant leurs idées et suggestions, et à créer une plus grande implication et connexion entre tous les collaborateurs et Vila Galé.",
		As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada: "Les idées ou suggestions reçues jusqu'à la fin de chaque trimestre seront évaluées par un VG LAB.",
		Para_participar_basta_preencher_o_formulário_em_papel: "Pour participer, il suffit de remplir le formulaire en papier ou en ligne (ERP/My Vila Galé).",
		As_ideias_apresentadas_serão_classificadas_em: "Les idées présentées seront classées selon 3 critères:",
		Relevantes_e_finalizadas_para_implementação_premiadas: "Pertinentes et finalisées pour mise en œuvre - primées;",
		Desenvolvimento_o_a_colaborador_a_será_convidado: "Développement - le collaborateur/la collaboratrice sera invité(e) à améliorer son idée afin qu'elle devienne réalisable;",
		Não_relevantes: "Non pertinentes.",
		A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor: "Les idées primées reçoivent un prix de 75€ en carte Sonae ou 100€ en bon d'incitation VG.",
		Fatores_eliminatórios_apenas_a_sugestão_ou_ideia: "Facteurs éliminatoires (seule la suggestion ou l'idée conforme à ceux-ci permettra sa nomination):",
		Inovação_e_originalidade: "Innovation et originalité",
		Valor_acrescentado_para_a_empresa: "Valeur ajoutée pour l'entreprise",
		Necessidade_de_implementação: "Nécessité de mise en œuvre",
		Exequibilidade_operacional: "Faisabilité opérationnelle",
		Método_de_implementação: "Méthode de mise en œuvre",
		Custos_de_implementação: "Coûts de mise en œuvre",
		As_ideias_ou_sugestões_relevantes_não_serão_premiadas: "Les idées ou suggestions pertinentes ne seront pas primées dans un premier temps, mais pourront l'être après développement par le collaborateur/la collaboratrice.",
		Em_caso_de_ideias_similares_apenas_uma_será_premiada: "En cas d'idées similaires, une seule sera primée. En suivant l'ordre de sélection suivant:",
		Mais_critérios_eliminatórios_adequados: "Plus de critères éliminatoires adéquats;",
		Custos_de_implementação_calculados: "Coûts de mise en œuvre calculés;",
		Data_de_submissão: "Date de soumission.",
		Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir: "Le VG LAB évaluateur se réserve le droit de ne pas attribuer de prix, si aucune idée n'a été présentée ou si les idées présentées ne remplissent pas les conditions d'attribution des prix.",
		Colaborador: "Collaborateur",
		Motivo: "Motif",
		Assunto: "Sujet",
		Categoria: "Catégorie",
		Descrição: "Description",
		Ficheiro: "Fichier",
		Imagem: "Image",
		Tipo: "Type",
		Não_foram_encontradas_cartas_para_o_hotel_selecionado: "Aucune carte n'a été trouvée pour l'hôtel sélectionné.",
		Menu: "Menu",
		Directório: "Annuaire",
		Marcação: "Marquage",
		Capitulo: "Chapitre",
		Erro_nos_subcapitulos: "Erreur dans les sous-chapitres.",
		Carta_copiada_com_sucesso: "Lettre copiée avec succès.",
		Erro_a_gravar: "Erreur d'enregistrement",
		O_campo_Hotel_é_obrigatório: "Le champ Hôtel est obligatoire.",
		Deseja_mesmo_apagar: "Voulez-vous vraiment supprimer?",
		Pretende_eliminar: "Souhaitez-vous supprimer",
		Erro_a_obter_hoteis: "Erreur lors de l'obtention des hôtels",
		Visivel: "Visible",
		Nome_Impressão: "Nom d'impression",
		Informação: "Information",
		moeda: "monnaie",
		Moeda: "Monnaie",
		armazem: "entrepôt",
		Armazém: "Entrepôt",
		Remover_Imagem: "Supprimer l'image",
		Adicionar_Imagem: "Ajouter une image",
		As_dimensões_da_imagem_devem_ser_800px_x_600px: "Les dimensions de l'image doivent être de 800px x 600px (obligatoire).",
		Esta_carta_já_foi_registada: "Cette lettre a déjà été enregistrée.",
		Registo_alterado_com_sucesso: "Enregistrement modifié avec succès",
		Registo_criado_com_sucesso: "Enregistrement créé avec succès.",
		Ocorreu_um_erro_ao_alterar_o_registo: "Une erreur s'est produite lors de la modification de l'enregistrement",
		Ocorreu_um_erro_ao_criar_o_registo: "Une erreur s'est produite lors de la création de l'enregistrement.",
		O_campo_Nome_é_obrigatório_no_idioma: "Le champ Nom est obligatoire dans la langue",
		O_campo_Moeda_é_obrigatório: "Le champ Monnaie est obligatoire.",
		O_campo_Armazém_é_obrigatório: "Le champ Entrepôt est obligatoire.",
		O_campo_Categoria_é_obrigatório: "Le champ Catégorie est obligatoire.",
		Ocorreu_um_erro: "Une erreur s'est produite.",
		Artigo_de_Venda: "Article de Vente",
		Este_menu_já_foi_registado: "Ce menu a déjà été enregistré.",
		Ordem_n: "Ordre (º)",
		Adicionar: "Ajouter",
		Não_foram_encontrados_capítulos: "Aucun chapitre trouvé.",
		O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a: "Le champ Ordre doit être numérique et supérieur ou égal à 0.",
		O_campo_Nome_é_obrigatório: "Le champ Nom est obligatoire.",
		Medidas: "Mesures",
		Artigo_de_Venda: "Article de Vente",
		Atualizar: "Mettre à jour",
		Não_foram_encontrados_subcapítulos: "Aucun sous-chapitre trouvé",
		Litro: "Litre",
		Decilitro: "Décilitre",
		Centilitro: "Centilitre",
		Mililitro: "Millilitre",
		Minuto: "Minute",
		Não_foram_encontrados_capítulos_para_o_idioma_seleccionado: "Aucun chapitre trouvé pour la langue sélectionnée.",
		O_campo_Quantidade_é_obrigatório: "Le champ Quantité est obligatoire.",
		O_campo_Medida_é_obrigatório: "Le champ Mesure est obligatoire.",
		O_campo_Preço_deve_ser_numérico: "Le champ Prix doit être numérique.",
		O_campo_Preço_é_obrigatório_e_deve_ser_numérico: "Le champ Prix est obligatoire et doit être numérique.",
		Não_foram_adicionadas_medidas: "Aucune mesure ajoutée.",
		O_campo_Preço_é_obrigatório: "Le champ Prix est obligatoire.",
		Zonas: "Zones",
		Data_de_Validade: "Date de Validité",
		Upload: "Télécharger",
		Destaque: "En Vedette",
		Pública: "Publique",
		Privada: "Privée",
		Resposta1: "1 Réponse",
		Várias_Opções: "Plusieurs Options",
		Resposta: "Réponse",
		A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif: "L'image doit être de type jpeg, jpg, png ou gif",
		O_ficheiro_tem_de_ser_um_pdf: "Le fichier doit être un PDF.",
		Lista_de_Notícias: "Liste des Nouvelles",
		Autor: "Auteur",
		Detalhe: "Détail",
		Data_Inicio: "Date de Début",
		Data_Fim: "Date de Fin",
		Evento_apagado: "Événement supprimé.",
		Deseja_mesmo_apagar_o_evento: "Voulez-vous vraiment supprimer l'événement?",
		Apagar: "Supprimer",
		O_evento_será_apagado_e_não_será_possível_recuperá_lo: "L'événement {name} sera supprimé et ne pourra pas être récupéré.",
		Privado: "Privé",
		Não_é_possível_visualizar_o_documento: "Impossible de visualiser le document.",
		Já_chegou_ao_limite_de_ficheiros: "Vous avez atteint la limite de fichiers.",
		Apenas_são_aceites_PDFs_documentos_Word_ou_imagens: "Seuls les PDF, documents Word ou images au format jpeg, jpg ou png sont acceptés.",
		O_ficheiro_não_pode_ter_mais_de_10mb: "Le fichier ne peut pas dépasser 10 Mo.",
		O_campo_Assunto_é_obrigatório: "Le champ Sujet est obligatoire.",
		O_campo_Categoria_é_obrigatório: "Le champ Catégorie est obligatoire.",
		O_campo_Descrição_é_obrigatório: "Le champ Description est obligatoire.",
		Passou_o_limite_de_caracteres_para_o_campo_Descrição: "Vous avez dépassé la limite de caractères pour le champ Description.",
		Participação_registada_com_sucesso: "Participation enregistrée avec succès.",
		Este_directório_já_foi_registado: "Cet annuaire a déjà été enregistré.",
		Só_é_permitido_um_directório_por_hotel: "Un seul annuaire est autorisé par hôtel.",
		Ficheiros: "Fichiers",
		Data_de_Início: "Date de Début",
		Data_de_Fim: "Date de Fin",
		A_Data_de_Início_não_está_selecionada: "La Date de Début n'est pas sélectionnée.",
		A_Data_de_Fim_não_está_selecionada: "La Date de Fin n'est pas sélectionnée.",
		Titulo: "Titre"
		
	},
	// Lang FR

}
